/**
 ______________________________________
 |                                      |
 |                OBTO                  |
 |      Building Smarter Institutions   |
 |    Copyright © 2016-2022 OBTO Inc.   |
 |______________________________________|
 
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 * =======================================================================
 * OBTO is FULLY owned and LICENSED by OBTO INC.
 * This script may NOT be RESOLD or REDISTRUBUTED under any
 * circumstances, and is only to be used with this purchased
 * copy of OBTO.
 * =======================================================================
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * =======================================================================
 * date: 3/30/08
 * filesize:
 * author: devverma
 * email: support@obto.co
 */
"use strict";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../scss/_custom.scss';
import 'feather-icons/dist/feather.min';
import '../../sources/bootstrap-datepicker/dist/css/bootstrap-datepicker3.standalone.min.css';
import '../../sources/bootstrap-select/dist/css/bootstrap-select.min.css';
import 'jquery-contextmenu/dist/jquery.contextMenu.min.css';
import 'ladda/dist/ladda-themeless.min.css';
import '../css/angular.treeview.css';
import '../common/css/xeditable.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'nprogress/nprogress.css';
import 'dropzone/dist/min/dropzone.min.css';
import 'select2/dist/css/select2.min.css';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'jQuery-QueryBuilder/dist/css/query-builder.default.min.css';
import 'jquery-typeahead/dist/jquery.typeahead.min.css';
import '../common/css/source/main.css';
import '../../sources/bootstrap-select/dist/js/bootstrap-select.min';
import 'jquery-steps/build/jquery.steps.min';
import 'ui-select/dist/select.min.css';
import "highlight.js/styles/github-dark-dimmed.min.css";
/* Core CSS required for Ionic components to work properly */

import 'react-calendar-timeline/lib/Timeline.css'
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

import '../common/js/jquery.event.drag-2.3.0';
import '../common/js/jquery.event.drop-2.3.0';
import '../common/js/jquery-ui-1.11.3';
import 'jquery-typeahead/dist/jquery.typeahead.min';

import moment from 'moment-timezone';
import * as _ from 'underscore';
// import async from 'async';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'eonasdan-bootstrap-datetimepicker';
import 'dropzone';
import 'select2/dist/js/select2.full.min';

import * as Ladda from 'ladda';
import feather from 'feather-icons';
import swal from 'sweetalert2';
import 'bootstrap4-notify';

import 'jQuery-QueryBuilder';
import * as angular from 'angular';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import ngRoute from 'angular-route';
import 'angular-drag-and-drop-lists';
import 'highcharts-ng';
import 'angular-ui-bootstrap';
import 'angular-bootstrap-contextmenu';
import * as NProgress from 'nprogress';
import * as PapaParser from 'papaparse';
import './module-dependencies';
import 'ui-select';
import './angular-validate.min';
import 'angular-xeditable';
import './angular-treeview';
import './obto-data-jqgrid';
import './obto-data-document';
import './obto-data-dashboard';
import './obto-data-performance';
import './obto-data-scriptconsole';
import './obto-data-calendar';
import './obto-data-canvas';
import './obto-data-reporting';
import './obto-data-obtemplate';
import './obto-data-service';
import './services/angularJsHttpService';
import './app.config';
import './common';
import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { createRoot } from "react-dom/client";
import store from './store';
import ngRedux from 'ng-redux';
import { Provider } from 'react-redux';
// import './JQGridReactWrapper';
// import rootReducer from './reducers'
// import thunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';
// import { default as DevTools, runDevTools} from './devTools';
import NavigationComponent from './components/Navigation';
import DynamicComponent from './components/DynamicComponent';
import $ from "jquery";
let bodySelector = $('body');
const obto = angular.module('obto-view-index', [
    'ngResource',
    'ngSanitize',
    'ngRoute',
    // 'ngIdle',
    'ui.bootstrap',
    'highcharts-ng',
    // 'chart.js',
    'ngValidate',
    'xeditable',
    'angularTreeview',
    'ngRedux',
    'ui.select',
    'ui.bootstrap.contextMenu',
    'app.localize',
    'app.controllers',
    'app.main',
    'obto.data.jqgrid',
    'obto.data.document',
    'obto.data.dashboard',
    'obto.data.scriptconsole',
    'obto.data.calendar',
    'obto.data.canvas',
    'obto.data.reporting',
    'obto.data.obtemplate'
]);

obto.config(['$routeProvider', '$locationProvider', '$validatorProvider', '$qProvider', '$httpProvider', '$sceDelegateProvider', '$logProvider', '$ngReduxProvider', function ($routeProvider, $locationProvider, $validatorProvider, $qProvider, $httpProvider, $sceDelegateProvider, $logProvider, $ngReduxProvider) {
    $ngReduxProvider.provideStore(store);
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    $logProvider.debugEnabled(false);

    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://freegeoip.net/**',
        'https://res.cloudinary.com/www-obto-co/**',
        'https://static.obto.co/**',
        'https://cdn.rawgit.com/**'
    ]);

    $httpProvider.interceptors.push('loginInterceptor');

    $qProvider.errorOnUnhandledRejections(false);

    Object.keys(window.CONFIG.routes)
        .forEach(function (route) {
            let routeDef = window.CONFIG.routes[route];
            $routeProvider.when(route, routeDef);
        });

    $routeProvider.otherwise({
        redirectTo: '/error404'
    });

    $validatorProvider.setDefaults({
        highlight: function (element) {
            $(element).closest('.form-group').removeClass('has-success').addClass('has-danger');
        },
        unhighlight: function (element) {
            $(element).closest('.form-group').removeClass('has-danger').addClass('has-success');
        },
        errorElement: 'span',
        errorClass: 'help-block',
        errorPlacement: function (error, element) {
            if (element.parent('.input-group').length) {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        }
    });

    $validatorProvider.addMethod('customphone', function (value, element) {
        return this.optional(element) || /^(\+91-|\+91|0)?\d{10}$/.test(value);
    }, "Please enter a valid phone number");

    $validatorProvider.addMethod('incomecheck', function (value, element) {
        return this.optional(element) || /^\d{0,4}(\.\d{0,2})?$/.test(value);
    }, "Please enter a valid income");

    $validatorProvider.addMethod('paymentcheck', function (value, element) {
        return this.optional(element) || /^(du)?\d{8}$/i.test(value);
    }, "Please enter a valid payment reference number");

    $validatorProvider.addMethod('adharcheck', function (value, element) {
        return this.optional(element) || /^\d{12}$/i.test(value);
    }, "Please enter a valid adhar card number");

    $validatorProvider.addMethod('namecheck', function (value, element) {
        return this.optional(element) || /^[A-Za-z\s]+$/.test(value);
    }, "Please enter a valid name");

    $validatorProvider.addMethod('dobcheck', function (value, element) {
        return moment.tz(value, 'DD-MM-YYYY', true).isValid();
    }, "Please enter a valid date");

    $validatorProvider.addMethod('customphone', function (value, element) {
        return this.optional(element) || /^(\+91-|\+91|0)?\d{10}$/.test(value);
    }, "Please enter a valid phone number");

}]);

obto.filter('matchName', function () {
    return function (values, query) {
        return values.filter(function (value) {
            //$log.log('value' + value[query]);
            return value[query];
        });
    };
});

obto.directive("afterRender", ["$timeout", "$ngRedux",
    function ($timeout, $ngRedux) {
        return {
            restrict: "A",
            terminal: true,
            transclude: false,
            link: function (scope, element, attrs) {
                $timeout(async () => {
                    // console.log('Rendering completed...');
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            "rendering_completed": true
                        }
                    });

                    try {
                        const mod = await import("feather-icons");
                        const feather = mod.default ?? mod;

                        $timeout(() => {
                            feather.replace({ width: 18, height: 18 });
                        }, 0, false);
                    } catch (e) {
                        console.log(e);
                    }
                }, 700); //Calling a scoped method
            },
        };
    },
]);

obto.provider('ladda', function () {
    var opts = {
        'style': 'zoom-in'
    };
    return {
        setOption: function (newOpts) {
            angular.extend(opts, newOpts);
        },
        $get: function () {
            return opts;
        }
    };
});

obto.run(['$route', '$rootScope', 'settings', '$http', '$timeout', '$uibModal', /*'Idle',*/ '$location', '$window', '$localstorage', '$document', 'editableOptions', '$log', 'OB', 'beforeUnload', 'localize', '$ngRedux', function ($route, $rootScope, settings, $http, $timeout, $uibModal, /*Idle,*/ $location, $window, $localstorage, $document, editableOptions, $log, OB, beforeUnload, localize, $ngRedux) {
    OB.init();
    bodySelector = $('body');
    bodySelector.addClass('initial-hide');

    $rootScope.header = {};
    let failedLoginAttempt = 0;
    const host = $location.host();
    const __ot = $location.search().__ot;
    if (__ot) {
        $localstorage.set("__ot", __ot);
    } else {
        $localstorage.remove("__ot");
    }
    //Remove __ot from url as well.

    $rootScope.header.host = host;
    $rootScope.header.realhost = (!host || host === "localhost") ? "dev" : host;
    editableOptions.theme = 'bs3';

    $rootScope.viewFiles = window.viewFiles;

    if ($localstorage.getObject("ob.edu")) {
        $rootScope.session = $localstorage.getObject("ob.edu").session;
        $rootScope.ob.session = $localstorage.getObject("ob.edu").session;
        $rootScope.sessionLabel = $localstorage.getObject("ob.edu").sessionLabel;
        $rootScope.ob.sessionLabel = $localstorage.getObject("ob.edu").sessionLabel;
    }

    if (typeof $localstorage.getObject("conversations") === "undefined") {
        $localstorage.setObject("conversations", {});
    } else {
        $rootScope.ob.conversations = $localstorage.getObject("conversations");
    }

    if (!$localstorage.getObject("ob").language) {
        localize.setLang("en");
        $rootScope.ob.language = "en";
    } else {
        localize.setLang($localstorage.getObject("ob").language);
        $rootScope.ob.language = $localstorage.getObject("ob").language;
    }


    $rootScope.requests401 = [];

    if (!$localstorage.getObject("ob").token) {
        $localstorage.setObject("ob", $rootScope.ob);
        $localstorage.setObject("ob.socket", { connection: undefined });
        $localstorage.set("isFirstLogin", true);
        console.log("OBTO: Storage created. Welcome to OBTO.");
    }

    $rootScope.boxinstance = {};
    /**
     * On 'logoutRequest' invoke logout on the server and broadcast 'event:loginRequired'.
     */
    const removeLogoutEventListner = $rootScope.$on('event:logoutRequest', function () {
        bodySelector.addClass('initial-hide');
        if ($location.path() !== "/") {
            $rootScope.redirectTo = $location.path();
        }

        $ngRedux.dispatch({
            type: 'LOGIN',
            payload: {
                "loginStatus": -1,
                "socketStatus": {
                    "status": "not_ready"
                }
            }
        });

        $localstorage.remove("clientConnected");

        $http.get('/o/logout').then(function (response) {

            delete $window.sessionStorage.token;

            $localstorage.remove("ob");
            $localstorage.remove("obto.apps");
            $localstorage.remove("obto.subapps");
            $localstorage.remove("ob.edu");
            $localstorage.remove("obto.user_name");
            $localstorage.remove("wsToken");
            $localstorage.remove("newui");

            if (!$localstorage.get("oversion")) {
                console.log("Global version not set");
                $localstorage.clear();
            }

            $rootScope.globalAttributes = {};
            $rootScope.globaloprops = {};
            $rootScope.oprops = {};
            $rootScope.oversion = 'SOMTHING';
            $rootScope.user = {};
            $rootScope.connectionlost = false;
            $rootScope._lurl = 'SOMTHING';
            $rootScope._csrf = 'SOMTHING';
            $rootScope.socketNamespace = 'SOMTHING';
            $rootScope.domain = null;
            $rootScope.token = 'SOMTHING';
            $rootScope.ob = {};
            $window.location.reload();
        });

    });

    const removeLoginEventListner = $rootScope.$on('event:loginRequired', function (e) {
        failedLoginAttempt += 1;
        $rootScope.showmodal = true;
        $rootScope.ob.isLoginOpen = true;
        // if (failedLoginAttempt === 1) {
        // bodySelector.addClass('initial-hide');

        let logoUrl = "https://res.cloudinary.com/www-obto-co/image/upload/c_thumb,w_200,g_face/v1616903065/OBTO/logo/New_OBTO_Logo_Dark_3.png";
        let copyrightNotice = "Copyright &copy; OBTO 2020-2021";
        let privacyTosAcceptance = "By logging in, you agree to OBTO's privacy policy and terms of use."
        let privacyPolicyLink = "https://www.obto.co/site/ob/privacy";
        let termsPolicyLink = "https://www.obto.co/site/ob/terms";
        let securityPolicyLink = "https://www.obto.co/site/ob/security";

        $http.get("/ms/v2/initialize.bto").then(function (response) {
            if (response.status === 200 && response.data) {
                logoUrl = response.data.logo;
                privacyTosAcceptance = response.data.privacyTosAcceptance;
                copyrightNotice = response.data.copyrightNotice;
                privacyPolicyLink = response.data.privacyPolicyLink;
                termsPolicyLink = response.data.termsPolicyLink;
                securityPolicyLink = response.data.securityPolicyLink;
            }

            $rootScope.ob.logourl = logoUrl;
            $rootScope.ob.privacyTosAcceptance = privacyTosAcceptance;
            $rootScope.ob.copyrightNotice = copyrightNotice;
            $rootScope.ob.privacyPolicyLink = privacyPolicyLink;
            $rootScope.ob.termsPolicyLink = termsPolicyLink;
            $rootScope.ob.securityPolicyLink = securityPolicyLink;
            $location.path('/login.bto');
            // window.location.href = '/ms/v2/auth.bto';
            window.__NAV_COLLAPSED__ = '90px;'
            NProgress.done();

        });
    });

    $rootScope.open = function (name, size) {

        if (!size) {
            size = "sm";
        }

        const modalInstance = $uibModal.open({
            animation: false,
            templateUrl: name, //'myModalContent.html'
            controller: "ModalInstanceCtrl",
            size: size,
            keyboard: false,
            backdrop: 'static',
            resolve: {
                items: function () {
                    return null; //$scope.items;
                },
                posrturl: function () {
                    return null; //$scope.posrturl;
                },
                name: function () {
                    return name;
                },

            }
        });

        if (name.startsWith("loading")) {
            return modalInstance;
        }

        modalInstance.result.then(function (selectedItem) {
            //$scope.selected = selectedItem;
            // $log.log(selectedItem);
        }).finally(function () {
            // $log.info('Modal dismissed at: ' + new Date());
            modalInstance.$destroy();
        });
    };

    $rootScope.openv2 = function (name, size) {

        if (!size) {
            size = "sm";
        }
        const parentElem = angular.element($document[0].querySelector('.obto-modal')); //angular.element($window.document.querySelectorAll('.obto-modal-1'));
        // console.log(parentElem);
        const modalInstance = $rootScope.loginModal = $uibModal.open({
            animation: false,
            templateUrl: name, //'myModalContent.html'
            controller: "ModalInstanceCtrl",
            size: size,
            keyboard: false,
            backdrop: 'static',
            appendTo: parentElem,
            windowTopClass: 'obto-modal-login',
            resolve: {
                items: function () {
                    return null; //$scope.items;
                },
                posrturl: function () {
                    return null; //$scope.posrturl;
                }

            }
        });
        // console.log($rootScope.loginModal)
        modalInstance.result.then(function (selectedItem) {
            //$scope.selected = selectedItem;
            // $log.log(selectedItem);
        }).finally(function () {
            // $log.info('Modal dismissed at: ' + new Date());
            modalInstance.$destroy();
        });
    };

    $rootScope.openv3 = function (name, size, payload) {

        if (!size) {
            size = "xl";
        }
        const parentElem = angular.element($document[0].querySelector('.obto-modal'));
        const modalInstance = $uibModal.open({
            templateUrl: name,
            controller: 'ModalInstanceCtrl',
            size: size,
            animation: false,
            // appendTo: parentElem,
            windowTopClass: 'obto-modal-document right',
            resolve: {
                parentScope: function () {
                    return $rootScope;
                },
                name: function () {
                    return name;
                },
                rootScope: function () {
                    return $rootScope;
                },
                payload: function () {
                    return payload;
                }

            }
        });
        // console.log($rootScope.loginModal)
        modalInstance.result.then(function (selectedItem) {
            //$scope.selected = selectedItem;
            // $log.log(selectedItem);
        }).finally(function () {
            // $log.info('Modal dismissed at: ' + new Date());
            modalInstance.$destroy();
        });
    };

    settings.currentLang = settings.languages[0]; // en

    $rootScope.hideLeftMenu = false;

    // Idle.watch();
    /**
     * Ping server to figure out if user is already logged in.
     */
    OB.ping();

    // OB.loadReducers();
    // OB.loadGlobalScripts();

    $rootScope.ob.productionName = $rootScope.globalAttributes['co.obto.product.name'] || "Ready. Set. Launch";

    $rootScope.$on('$viewContentLoaded', function () {
        // Re-apply content styles after view is loaded
        const COLLAPSED_WIDTH = 90;
        const EXPANDED_WIDTH = 240;
        const collapsed = window.__NAV_COLLAPSED__; // Set this from React on collapse/expand

        const width = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;
        const contentEl = document.getElementById('content');
        if (contentEl) {
            contentEl.style.marginLeft = `${width}px`;
            contentEl.style.width = `calc(100% - ${width}px)`;
            contentEl.style.maxWidth = `calc(100% - ${width}px)`;
            contentEl.style.transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        }
    });
}]);

obto.filter('navFilter', ['_', function (_) {
    return function (items, parentApp) {
        if (!_.isUndefined(items)) {

            let filtered = [];
            _.each(items, function (e, i, arr) {
                if (e.application === parentApp) {
                    ////console.log("parentApp" + parentApp);
                    filtered.push(e);
                }
            });
            return filtered;
        }
    };
}]);

obto.controller('OBHead', ['$scope', '$location', function ($scope, $location) {
    $scope.header = {};
    const host = $location.host();
    $scope.header.host = host;
    $scope.header.realhost = (!host || host === "localhost") ? "dev" : host;
}]);

obto.controller('OBMain', ['$rootScope', '$scope', '$location', '$log', '$http', 'pqs', '$window', '$timeout', 'async', '$localstorage', '$document', '$sce', 'syncFactory', 'localize', 'socketFactory', 'ScriptLoader', function ($rootScope, $scope, $location, $log, $http, pqs, $window, $timeout, async, $localstorage, $document, $sce, syncFactory, localize, socketFactory, ScriptLoader) {

    $scope.logout = () => {
        $rootScope.$broadcast('event:logoutRequest', {});
    };

    $scope.navigationComponent = NavigationComponent;

    $rootScope.coreviewer = $scope.coreviewer = {};

    $rootScope.$on('event:Notificationpulldown', function (event, data) {
        $scope.notif.systemmessage = $sce.trustAsHtml(data.notification);
        $scope.coreviewer.isnewmessage = true;
    });

    $rootScope.$on('event:Notificationpullup', function (event, data) {
        $scope.coreviewer.isnewmessage = false;
    });

    $scope.getInitials = function (name) {

        var canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.width = '32';
        canvas.height = '32';
        document.body.appendChild(canvas);
        var context = canvas.getContext('2d');
        context.fillStyle = "#999";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = "16px Arial";
        context.fillStyle = "#ccc";
        var first, last;
        if (name && name.first && name.first !== "") {
            first = name.first[0];
            last = name.last && name.last !== "" ? name.last[0] : null;
            if (last) {
                var initials = first + last;
                context.fillText(initials.toUpperCase(), 3, 23);
            } else {
                var initials = first;
                context.fillText(initials.toUpperCase(), 10, 23);
            }
            var data = canvas.toDataURL();
            document.body.removeChild(canvas);
            return data;
        } else {
            return false;
        }
    }

    const updateOnlineStatus = (event) => {
        let condition = navigator.onLine;
        if (condition) {
            $log.info("just came back online, enable links");
            $scope.coreviewer.connectionlost = false;
            if (!$scope.coreviewer.isnewmessage)
                $scope.resetAside = {
                    'top': '0px'
                };
            else
                $scope.resetAside = {
                    'top': '39px'
                };
        } else {
            $log.info("we just lost our connection and entered offline mode, disable eternal link");
            $scope.coreviewer.connectionlost = true;
            $scope.resetAside = {
                'top': '39px'
            };
        }
        $scope.$digest();

    };

    const retry = (req) => {
        $http(req.config).then(function (response) {
            req.deferred.resolve(response);
        });
    };

    $scope.sys_dismiss_notification = () => {
        $log.info("Notification dismissed..");
        $scope.coreviewer.isnewmessage = false;
        $scope.$digest();
    };

    $scope.setEduSession = (session) => {

        console.log('setEduSession')

        let SESSION = $localstorage.getObject("ob.edu").session || $rootScope.ob.session;
        if (session) {
            SESSION = session;
        }
        $rootScope.session = SESSION;
        $rootScope.ob.session = SESSION;

        $rootScope.sessionLabel = ($rootScope.globalAttributes['co.obto.edu.session.label']) ? $rootScope.globalAttributes['co.obto.edu.session.label'] + " - " + $rootScope.ob.session : "Session" + " - " + $rootScope.ob.session;
        $rootScope.ob.sessionLabel = ($rootScope.globalAttributes['co.obto.edu.session.label']) ? $rootScope.globalAttributes['co.obto.edu.session.label'] + " - " + $rootScope.ob.session : "Session" + " - " + $rootScope.ob.session;

        let eduSession = {
            session: $rootScope.ob.session,
            sessionLabel: $rootScope.ob.sessionLabel
        };
        $localstorage.setObject("ob.edu", eduSession);
        $log.info("Session switched.");

        setTimeout(() => {
            $window.location.reload(true);
        }, 500);
    };

    $scope.ob.searchterm = "";

    $scope.search = () => {
        // console.log($scope.ob.searchterm);
        $location.path('/page');
        $location.search('pagename', 'ob-search');
        $location.search('term', $scope.ob.searchterm);
    };

    $scope.stream_log = false;
    $scope.enableLogStream = function () {
        window.open(`${window.location.origin}/page?pagename=devzone`, '_blank');
    };

    $rootScope.ob.languageLabel = $localstorage.getObject("ob").languageLabel || "English";

    $scope.setLanguage = (lang) => {
        localize.setLang(lang);
        $rootScope.ob.languageLabel = $rootScope.ob.languages[lang];
        $rootScope.ob.language = lang;
        let _OB = $localstorage.getObject("ob");
        _OB.languageLabel = $rootScope.ob.languages[lang];
        _OB.language = lang;
        $localstorage.setObject("ob", _OB);
        $log.info("Language switched.");
        setTimeout(() => {
            $window.location.reload(true);
        }, 500);
    };

    const initPlatform = function (_event, _data) {
        $rootScope.hideTopMenu = false;

        try {
            $rootScope.loginModal.close('ok');
        } catch (e) {

        }

        /*************** On Load Set Edu Props*********/
        $log.debug("EDU Site: ", $rootScope.isEdu);

        if ($rootScope.isEdu) {
            $rootScope.ob.isEdu = true;
            $rootScope.ob.logourl = $rootScope.globalAttributes['co.obto.customer.logourl'] || "https://static.obto.co/ob/assets/dist/2.0/img/sofos-logo-312x312.png";
            $rootScope.$broadcast('event:titlechanged', "SOFOS");
            if ($localstorage.getObject("ob.edu").session) {
                $rootScope.session = $localstorage.getObject("ob.edu").session;
                $rootScope.ob.session = $localstorage.getObject("ob.edu").session;
                $rootScope.sessionLabel = $localstorage.getObject("ob.edu").sessionLabel || "Session";
                $rootScope.ob.sessionLabel = $localstorage.getObject("ob.edu").sessionLabel || "Session";
            } else {
                $rootScope.session = $rootScope.globalAttributes['co.obto.edu.current.session'] || moment.tz().year() + "-" + moment.tz().add(1, 'year').year().toString().substr(2, 4);
                $rootScope.sessionLabel = ($rootScope.globalAttributes['co.obto.edu.session.label']) ? $rootScope.globalAttributes['co.obto.edu.session.label'] + " - " + $rootScope.session : "Session" + " - " + $rootScope.session;

                $rootScope.ob.session = $rootScope.globalAttributes['co.obto.edu.current.session'] || moment.tz().year() + "-" + moment.tz().add(1, 'year').year().toString().substr(2, 4);
                $rootScope.ob.sessionLabel = ($rootScope.globalAttributes['co.obto.edu.session.label']) ? $rootScope.globalAttributes['co.obto.edu.session.label'] + " - " + $rootScope.ob.session : "Session" + " - " + $rootScope.ob.session;
            }

        } else {
            $rootScope.ob.isEdu = false;
            $rootScope.ob.logourl = $rootScope.globalAttributes['co.obto.customer.logourl'] || "https://static.obto.co/ob/assets/dist/2.0/img/sofos-logo-312x312.png";
        }

        let i, requests = $rootScope.requests401;
        for (i = 0; i < requests.length; i++) {
            retry(requests[i]);
        }
        $rootScope.requests401 = [];
        $scope.notif = {};
        $rootScope.mycolor = "#B31919;";
        $rootScope.typingindicator = "Other user is typing....";
        $rootScope.activeClass = {};
        $scope.chatUsers = [];
        $rootScope.myChatSettings = {
            from_username: $rootScope.ob.user.userid,
            picture: $rootScope.user.display_picture
        };

        moment.tz.setDefault($rootScope.timezone);

        $scope.coreviewer.connectionlost = false;
        $scope.Socket = "";
        $scope.resetAside = {
            'top': '0px'
        };

        if ($rootScope.user.roles.indexOf("oad") > -1) {
            // $scope.hasAccess = true;
            $rootScope.ob.access.upload = true;
            $rootScope.ob.access.download = true;
            $rootScope.ob.access.addfield = true;
            $rootScope.ob.access.json = true;
            $rootScope.ob.access.addfield = true;
        }

        if ($rootScope.user.roles.indexOf("developer") > -1 || $rootScope.user.roles.indexOf("super") > -1) {
            $rootScope.ob.access.view_schema = true;
        }

        if ($rootScope.user.last_login_time === "false" && localStorage.getItem("isFirstLogin") === "true") {
            // $scope.open('firstlogin.html', 'lg');
        }

        $rootScope.ob.isLoginOpen = false;
        socketFactory.initiate();
    };

    $window.addEventListener('online', updateOnlineStatus);

    $window.addEventListener('offline', updateOnlineStatus);

    $window.addEventListener("load", function (e) {
        if ($("#left-panel").height() > 120) {
            $rootScope.$broadcast('unset.menu.on.top');
        }
    }, false);

    $rootScope.$on('event:loginConfirmed', initPlatform);

    $rootScope.$on('event:loggedIn', initPlatform);

}]);

obto.controller('RouteController', ['$scope', '$routeParams', '$window', '$http', '$log', '$timeout', function ($scope, $routeParams, $window, $http, $log, $timeout) {

    // $scope.totalItems = 64;
    // $scope.currentPage = 4;
    // $scope.cdnpath = '';
    // $scope.tags = '';
    $scope.input = {
        collection: "global"
    }
    // $scope.setPage = function (pageNo) {
    //     $scope.currentPage = pageNo;
    // };

    // $scope.currentTab = 'local';

    // $scope.setTab = (name) => {
    //     alert(name);
    //     $scope.currentTab = name;
    // };

    // $scope.pageChanged = function () {
    //     $log.log('Page changed to: ' + $scope.currentPage);
    // };

    // $scope.maxSize = 5;
    // $scope.bigTotalItems = 175;
    // $scope.bigCurrentPage = 1;


    // $scope.action = {
    //     localstore: true,
    //     custom: false
    // };

    // $scope.action.showalbum = false;

    // $scope.existingFiles = {};

    // // if($scope.cdnpath){
    // //     console.log('$scope.cdnpath', $scope.cdnpath);
    // // }

    // $scope.$watch('cdnpath', (n, o) => {
    //     console.log('$scope.cdnpath', $scope.cdnpath);
    // });

    // $scope.setTags = (val) => {
    //     console.log('$scope.cdnpath', $scope.cdnpath, val);
    //     $scope.tags = [val];
    // };
}]);

obto.controller('ManageCollectionController', ['$scope', '$http', '$log', '$uibModal', '$document', '$rootScope', function ($scope, $http, $log, $uibModal, $document, $rootScope) {

    let SELECTED_COLLECTIONS = [];

    $scope.searchTerm = ""
    let all_collections = [];

    $scope.openCollectionModel = (name, size) => {
        // console.log(name);
        if (!size) {
            size = "sm";
        }
        const parentElem = angular.element($document[0].querySelector('.obto-modal'));
        const modalInstance = $uibModal.open({
            animation: false,
            templateUrl: name,
            controller: "ModalInstanceCtrl3",
            windowTopClass: 'obto-modal-document',
            size: size,
            keyboard: false,
            backdrop: 'static',
            resolve: {
                items: function () {
                    return [];
                }
            }
        });

        modalInstance.result.then(function (selectedItem) {
            $scope.selected = selectedItem;
            $log.log(selectedItem);
        }).finally(function () {
            $log.info('Modal dismissed at: ' + new Date());
            modalInstance.$destroy();
        });
    };

    $http.get("/o/listcollection.bto").then(function (response) {
        $log.debug(response);

        _.map(response.data, function (val, key) {
            val['selected'] = false;
        });

        all_collections = response.data;

        $scope.collections = response.data;
    });

    $scope.SEARCH = () => {
        if (!$scope.searchTerm) {
            return $scope.collections = all_collections;
        }
        $scope.collections = all_collections.filter(val => val.name.toLowerCase().startsWith($scope.searchTerm.toLowerCase()));
    }

    $scope.REFRESH = () => {
        $http.get("/o/listcollection.bto").then(function (response) {
            $log.debug(response);

            _.map(response.data, function (val, key) {
                val['selected'] = false;
            });

            $scope.collections = response.data;
        });
    };

    $scope.$watch("collections", (n, o) => {
        if (n && n.length !== 0) {
            SELECTED_COLLECTIONS = _.filter($scope.collections, (val) => {
                return val.selected;
            });

            $log.info(SELECTED_COLLECTIONS);
        }
    }, true);

    $scope.$watch("searchTerm", (n, o) => {
        if (!n) {
            $scope.collections = all_collections;
        }
    }, true);

    $scope.EMPTY = function () {

        if (!SELECTED_COLLECTIONS.length) {
            return swal("Select collection ?", "We won't be removivng any records today!", "error");
        }

        swal({
            title: "Are you sure to delete all records?",
            // text: "Would you like to delete all records",
            type: "info",
            showCancelButton: true,
            cancelButtonClass: "btn-default",
            confirmButtonText: "Proceed",
            confirmButtonClass: "btn-primary",
            html: '<input id="swal-input1" class="swal2-input" placeholder="Type DELETE to confirm" />',
            preConfirm: () => {
                return [
                    document.getElementById('swal-input1').value
                ];
            },
        }).then(function (result) {
            $log.debug(result);
            if (result.value && result.value[0].toUpperCase() === "DELETE") {
                let request = $http({
                    method: "post",
                    url: "/o/emptycollection.bto",
                    data: {
                        collection_name: SELECTED_COLLECTIONS[0].name
                    }
                });
                // Store the data-dump of the FORM scope.
                request.then(function (response) {
                    swal.close();
                });
            } else {
                swal("Cancelled", "We won't be removivng any records today!", "error");
                $('#modal-form').modal('hide');
            }
        });
    };

    $scope.DROP = function () {
        if (!SELECTED_COLLECTIONS.length) {
            return swal("Select collection ?", "We won't be removivng any records today!", "error");
        }
        swal({
            title: "Are you sure to DROP this collection?",
            // text: "Would you like to delete all records",
            type: "info",
            showCancelButton: true,
            cancelButtonClass: "btn-default",
            confirmButtonText: "Proceed",
            confirmButtonClass: "btn-primary",
            html: '<input id="swal-input1" class="swal2-input" placeholder="Type DROP to confirm" />',
            preConfirm: () => {
                return [
                    document.getElementById('swal-input1').value
                ];
            },
        }).then(function (result) {
            $log.debug(result);
            if (result.value && result.value[0].toUpperCase() === "DROP") {
                let request = $http({
                    method: "post",
                    url: "/o/dropcollection.bto",
                    data: {
                        collection_name: SELECTED_COLLECTIONS[0].name
                    }
                });
                // Store the data-dump of the FORM scope.
                request.then(function (response) {
                    swal.close();
                });
            } else {
                swal("Cancelled", "We won't drop any collections today!", "error");
                $('#modal-form').modal('hide');
            }
        });
    };

    let _2first = document.querySelector("#content");
    let controls_collections = $("#controls_collections");
    const _registerEvent = (e) => {

        if (_2first.scrollTop > 70) {
            controls_collections.addClass("controls-fix");
            console.log(_2first.scrollTop);
            $rootScope.$broadcast("event:past70");
        } else {
            controls_collections.removeClass("controls-fix");
        }
    };
    _2first.addEventListener("scroll", _registerEvent);

    $scope.$on("$destroy", () => {
        // console.log("_2first", _2first);
        _2first.removeEventListener("scroll", _registerEvent);
    });

    // $rootScope.$on("event:past70", (e, d) => {
    //     // console.log("event:past70");
    // })

}]);

obto.controller('LoginCtrl', ['$scope', '$rootScope', '$location', '$http', '$ngRedux', '$window', function ($scope, $rootScope, $location, $http, $ngRedux, $window) {

    $scope.loginFailed = false;
    $ngRedux.subscribe(function () {
        let state = $ngRedux.getState();
        NProgress.done();
        if (state.login) {
            $scope.loginFailed = state.login.loginStatus === -1;
            const contentEl = document.getElementById('content');
            const COLLAPSED_WIDTH = 90;
            const EXPANDED_WIDTH = 240;
            const collapsed = window.__NAV_COLLAPSED_ || false; // Set this from React on collapse/expand
            let width = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;
            if ($scope.loginFailed) {
                width = 0;
                if (contentEl) {
                    contentEl.style.marginLeft = `0px`;
                    contentEl.style.width = `100%`;
                    contentEl.style.maxWidth = `100%`;
                    contentEl.style.transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 100);
                }
            }
            if (contentEl) {
                contentEl.style.marginLeft = `${width}px`;
                contentEl.style.width = `calc(100% - ${width}px)`;
                contentEl.style.maxWidth = `calc(100% - ${width}px)`;
                contentEl.style.transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 100);
            }
        }
    });

    $scope.header = {};
    const host = $location.host();
    $scope.header.host = host;
    $scope.header.realhost = (!host || host === "localhost") ? "dev" : host;
    const self = this;
    if (!$rootScope.ob.isLoginOpen) {
        return $location.path("/");
    }
    const bodySelector = $('body');
    bodySelector.removeClass('initial-hide');

    $scope.viewer = {
        showlogin: true,
        showinit: true,
        showotp: false,
        password: false,
        buttonText: "Get Code"
    };

    $scope.resetLogin = () => {
        $scope.viewer = {
            showlogin: true,
            showinit: true,
            showotp: false,
            password: false,
            buttonText: "Get Code"
        };
    };

    $rootScope.hideTopMenu = true;

    let $ctrl = $scope;

    $ctrl.user = {
        user_name: "",
        user_password: "",
        mobile_number: "",
        location: "IN",
        otp: "",
        new_password: "",
        confirm_password: ""
    };

    $ctrl.userftl = {};
    _.extend($ctrl.userftl, $rootScope.ob.user);

    $ctrl.login = () => {
        $rootScope.hideTopMenu = true;
        $rootScope.$broadcast('event:loginRequest', $ctrl.user);
        NProgress.start();
    };

    $rootScope.hideTopMenu = true;
    $ctrl.user.location = "IN";

    $ctrl.recover = () => {
        if (!$scope.viewer.showotp && !$scope.viewer.password) {
            const otprequest = {
                user_name: $ctrl.user.user_name,
                mobile_number: $ctrl.user.location + $ctrl.user.mobile_number.toString(),
                email: ""
            };

            $http({
                method: "post",
                url: "/ms/forgotpassword", //$scope.values["_id"],
                data: JSON.stringify(otprequest)
            }).then(function (response) {

                if (response.status !== 200) {
                    $.notify({
                        title: '<strong>Failed!</strong>',
                        message: 'Problem saving information. Please contact admin.'
                    }, {
                        type: 'danger',
                        z_index: 1091
                    });
                } else {
                    $scope.viewer.showotp = true;
                    $scope.viewer.showint = false;
                    $scope.viewer.buttonText = "Validate Code";

                    $.notify({
                        title: '<strong>SMS Code Sent!</strong>',
                        message: 'Please check your SMS inbox'
                    }, {
                        type: 'success',
                        z_index: 1091
                    });
                }

            });
        }

        if ($scope.viewer.showotp) {
            const valotprequest = {
                user_name: $ctrl.user.user_name,
                otp: $ctrl.user.otp
            };

            $http({
                method: "post",
                url: "/ms/validateotp", //$scope.values["_id"],
                data: JSON.stringify(valotprequest)
            }).then(function (response) {

                if (!response.data.success) {
                    $.notify({
                        title: '<strong>Incorrect Code!</strong>',
                        message: 'Problem validating SMS code. Please contact admin.'
                    }, {
                        type: 'danger',
                        z_index: 1091
                    });
                } else {
                    $scope.viewer.showint = false;
                    $scope.viewer.password = true;
                    $scope.viewer.showotp = false;
                    $scope.viewer.showlogin = false;
                    $scope.viewer.buttonText = "Reset Password";

                    $.notify({
                        title: '<strong>Success</strong>',
                        message: 'Please reset your password'
                    }, {
                        type: 'success',
                        z_index: 1091
                    });
                }

            });
        }


        if ($scope.viewer.password) {

            if ($ctrl.user.new_password !== $ctrl.user.confirm_password) {
                return $.notify({
                    title: '<strong>Problem!</strong>',
                    message: 'Passwords do not match'
                }, {
                    type: 'danger',
                    z_index: 1091
                });
            }

            const resetrequest = {
                new_password: $ctrl.user.new_password,
                user_name: $ctrl.user.user_name
            };

            $http({
                method: "post",
                url: "/ms/resetpassword",
                data: JSON.stringify(resetrequest)
            }).then(function (response) {

                $scope.viewer.showotp = false;
                $scope.viewer.showint = false;

                if (!response.data.success) {
                    $.notify({
                        title: '<strong>Failed to reset!</strong>',
                        message: 'Problem saving your new password. Please contact admin.'
                    }, {
                        type: 'danger',
                        z_index: 1091
                    });
                } else {

                    $.notify({
                        title: '<strong>Success</strong>',
                        message: 'Password has been reset'
                    }, {
                        type: 'success',
                        z_index: 1091
                    });
                    $scope.resetLogin();
                    $scope.viewer.showlogin = true;
                }

            });
        }

    };

    $ctrl.forgotpassword = () => {
        $scope.resetLogin();
        $scope.viewer.showlogin = false;
    };

    $ctrl.remember = () => {
        $scope.resetLogin();
        $scope.viewer.showlogin = true;
    };

}]);

obto.controller('ModalInstanceCtrl', ['$uibModalInstance', '$scope', '$rootScope', '$location', '$http', '$localstorage', '$timeout', '$log', 'name', 'payload', ($uibModalInstance, $scope, $rootScope, $location, $http, $localstorage, $timeout, $log, name, payload) => {
    $scope.dynamic = 0;
    $scope.columnName = ['name', 'present', 'comment'];
    $scope.parentDivId = 'ribbonlistview';
    $scope.message = "";
    $scope.title = "new one";
    $scope.is_capped = false;
    $scope.queryparams = '';
    $scope.jqgridContainer = "jqgridContainer";
    $scope.params = {
        "shownavGrid": false,
        "pagesize": 10,
        "editenabled": true
    };
    $scope.next = "Next";

    $scope.viewer = {
        showlogin: true,
        showinit: true,
        showotp: false,
        password: false,
        buttonText: "Get Code"
    };

    switch (name) {
        case 'showconnect.html':
            setTimeout(() => {
                $rootScope.$emit("event.render.connect", {});
            }, 700);
            break;
        case 'platform_support.html':
            setTimeout(() => {
                $rootScope.$emit("event.render.help.support", {});
            }, 700);
            break;
        case 'fieldoptions':
            setTimeout(() => {
                $rootScope.$emit("event.render.subform.started", payload);
            }, 700);
            break;
        case 'formrelations':
            setTimeout(() => {
                $rootScope.$emit("event.render.subform.started", payload);
            }, 700);
            break;
        default:
            setTimeout(() => {
                $rootScope.$emit(`event.render.${name}`, payload || {});
            }, 700);
    }

    let $ctrl = $scope;

    $ctrl.CREATE = function () {
        $scope.createcollectionform.$setPristine();

        if (!$scope.createcollectionform.$valid || $scope.createcollectionform.$invalid) {
            $log.debug($scope.createcollectionform);
            return swal("Problem", 'Required field is empty!', "error");
        }
        NProgress.start();

        const isCapped = $scope.is_capped || false;
        const createOptions = {
            capped: isCapped
        }
        if (isCapped) {
            _.extend(createOptions, {
                size: $scope.capped_size || 0,
                max: $scope.capped_max || 0
            });
        }
        swal({
            title: "Are you sure?",
            text: "Would you like to make changes to this collection?",
            type: "info",
            showCancelButton: true,
            cancelButtonClass: "btn-default",
            confirmButtonText: "Create",
            confirmButtonClass: "btn-primary"
        }).then(function (result) {
            $log.debug(result);
            if (result.value) {
                let request = $http({
                    method: "post",
                    url: "/o/createcollection.bto",
                    data: {
                        collection_name: $scope.collection_name,
                        options: createOptions,
                        _csrf: $scope._csrf
                    }
                });

                // Store the data-dump of the FORM scope.
                request.then(function (response) {
                    NProgress.done();
                    if (response.status === 200) {
                        swal("Succes", "Collection Created", "success");
                    } else {
                        swal("Problem", response.data, "error");
                    }
                    $uibModalInstance.dimiss('cancel');
                    $('#modal-form').modal('hide');

                });
            } else {
                NProgress.done();
                swal("Cancelled", "We won't create any applications today!", "error");
                $uibModalInstance.dimiss('cancel');
                $('#modal-form').modal('hide');
            }
        });
    };

    $scope.firstLoginCallback = function () {

        let wizardData = {};
        _.extend(wizardData, $ctrl.userftl);

        wizardData.last_login_time = new Date();
        wizardData.domain = $rootScope.domain;
        try {
            delete wizardData.userfullname;
            delete wizardData.userid;
            delete wizardData.username;
            delete wizardData.timezone;

        } catch (e) {

        }
        if (!wizardData.user_password || wizardData.user_password.length === 0) {
            console.log("Password is blank");
            $.notify({
                title: '<strong>Failed!</strong>',
                message: 'Password cannot be blank.'
            }, {
                type: 'danger',
                z_index: 1091
            });
            return;
        }
        // console.log(wizardData);

        $http({
            method: "post",
            url: "/o/pltf_user/" + $rootScope.userid, //$scope.values["_id"],
            data: JSON.stringify(wizardData)
        }).then(function (response) {

            if (response.status === 200) {

                $localstorage.set('isFirstLogin', false);

                $.notify({
                    title: '<strong>Success!</strong>',
                    message: 'Your information has been updated'
                }, {
                    type: 'success',
                    z_index: 1091
                });
                $rootScope.last_login_time = new Date();

                $timeout(function () {

                    $.notify({
                        title: '<strong>Success!</strong>',
                        message: 'You will now be logged out for security reasons. Please login back with your new password.'
                    }, {
                        type: 'success',
                        z_index: 1091
                    });
                }, 3000);

                $timeout(function () {
                    $uibModalInstance.close("ok");
                    // window.location.assign("/o/logout");
                    $rootScope.$broadcast('event:logoutRequest', {});
                }, 7000);

                return;
            }

            $.notify({
                title: '<strong>Failed!</strong>',
                message: 'Problem saving information. Please contact admin.'
            }, {
                type: 'danger',
                z_index: 1091
            });

        });

    };

    $ctrl.ok = function () {
        $uibModalInstance.close();
    };

    $ctrl.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);

obto.controller('ModalDemoCtrl', ['$scope', '$uibModal', '$http', '$log', '$location', '$rootScope', function ($scope, $uibModal, $http, $log, $location, $rootScope) {

    ////console.log(JSON.stringify($location.host()));
    var host = $location.host();
    $scope.posrturl = '/o/registration';
    $scope.showMe = false;

    if (host.indexOf('.') < 0)
        host = "";
    else
        host = host.split('.')[0];

    if (host === 'dev' || host === 'edu' || $location.host().indexOf('.obto.org') > -1) {
        $scope.showMe = true;
    }

    $scope.animationsEnabled = false;
    $scope.open = function (name, size) {

        if (!size) {
            size = "sm";
        }

        if (name === 'newapplication.html') {
            $scope.posrturl = '/o/pltf_application_app';
        }

        let modalInstance = $uibModal.open({
            animation: $scope.animationsEnabled,
            templateUrl: name, //'myModalContent.html'
            controller: "ModalInstanceCtrl",
            size: size,
            keyboard: false,
            backdrop: 'static',
            resolve: {
                items: function () {
                    //return $scope.items;
                },
                posrturl: function () {
                    return $scope.posrturl;
                }

            }
        });

        if (name === "loading.html") {
            return modalInstance;
        }

        modalInstance.result.then(function (selectedItem) {
            //$scope.selected = selectedItem;
            $log.log($scope.selected);
        }, function () {
            $log.info('Modal dismissed at: ' + new Date());
        });
    };

}]);

obto.directive('smartDeviceDetect', ['$rootScope', function ($rootScope) {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-device-detect data-smart-device-detect');

            var isMobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
            //console.log("isMobile :" + isMobile)
            tElement.toggleClass('desktop-detected', !isMobile);
            tElement.toggleClass('mobile-detected', isMobile);

            if (isMobile) {
                tElement.removeClass('menu-on-top');
                $rootScope.$broadcast('requestToggleMenu');
            } else {
                tElement.addClass('menu-on-top');
                //element.removeClass('menu-on-top');//hidden-menu
            }

            $rootScope.$on('set.menu.on.top', function (event, data) {
                tElement.addClass('menu-on-top');
            });

            $rootScope.$on('unset.menu.on.top', function (event, data) {
                tElement.removeClass('menu-on-top');
            });


        }
    };
}]);

obto.directive('smartRouterAnimationWrap', ['$rootScope', '$timeout', '_', function ($rootScope, $timeout, _) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-router-animation-wrap data-smart-router-animation-wrap wrap-for data-wrap-for');

            element.addClass('router-animation-container');


            $('<div class="router-animation-loader"><i class="fa fa-gear fa-4x fa-spin"></i></div>').appendTo(element);


            var animateElementSelector = attributes.wrapFor;
            var viewsToMatch = attributes.smartRouterAnimationWrap.split(/\s/);

            var needRunContentViewAnimEnd = false;

            function contentViewAnimStart() {
                needRunContentViewAnimEnd = true;
                element.css({
                    height: element.height() + 'px',
                    overflow: 'hidden'
                }).addClass('active');

                $(animateElementSelector).addClass('animated faster fadeOutDown');
            }

            function contentViewAnimEnd() {


                if (needRunContentViewAnimEnd) {
                    element.css({
                        height: 'auto',
                        overflow: 'visible'
                    }).removeClass('active');

                    $(animateElementSelector).addClass('animated faster fadeInUp');

                    needRunContentViewAnimEnd = false;

                    $timeout(function () {
                        $(animateElementSelector).removeClass('animated');
                    }, 10);
                }
            }


            let destroyForStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                var isAnimRequired = _.any(viewsToMatch, function (view) {
                    return _.has(toState.views, view) || _.has(fromState.views, view);
                });
                if (isAnimRequired) {
                    ////console.log("I am being called to kill")
                    contentViewAnimStart();
                }
            });

            let destroyForEnd = $rootScope.$on('$viewContentLoaded', function (event) {
                contentViewAnimEnd();
            });

            element.on('$destroy', function () {
                destroyForStart();
                destroyForEnd();

            });


        }
    };
}]);

obto.directive("fileread", [function () {
    return {
        scope: {
            fileread: "="
        },
        link: function (scope, element, attributes) {
            element.bind("change", function (changeEvent) {

                var reader = new FileReader();
                reader.onload = function (loadEvent) {
                    ////console.log(loadEvent.target.result);
                    scope.$digest(function () {
                        scope.fileread = loadEvent.target.result;
                    });
                };
                reader.readAsDataURL(changeEvent.target.files[0]);
            });
        }
    };
}]);

obto.directive("obDatepicker", [function () {
    return {
        scope: {},
        link: function (scope, element, attributes) {
            element.datepicker({
                format: 'd-m-yyyy',
                autoclose: true,
                clearBtn: true
            });
        }
    };
}]);

obto.directive("obDateTimepicker", [function () {
    return {
        scope: {},
        link: function (scope, element, attributes) {
            element.datetimepicker({
                locale: 'en',
                icons: {
                    time: "fa fa-clock-o",
                    date: "fa fa-calendar",
                    up: "fa fa-arrow-up",
                    down: "fa fa-arrow-down",
                    format: 'DD-MM-YYYY',
                    keepOpen: true,
                    widgetPositioning: {
                        horizontal: 'auto',
                        vertical: 'auto'
                    }
                }
            });
        }
    };
}]);

obto.directive('smartSelect2', ['$timeout', '$window', '$localstorage', '$log', '$rootScope', function ($timeout, $window, $localstorage, $log, $rootScope) {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            collection: "@",
            query: "@",
            displayfield: "@",
            inputType: "@"
        },
        link: function (scope, element, attributes, ngModel) {
            scope.gselectValue = {};
            if (!scope.inputType) {
                scope.inputType = "option";
            }
            const isMultiple = attributes.multiple || false;
            if (scope.collection && scope.inputType === "gselect") {
                scope.gselectValue[attributes.name] = {
                    id: "none",
                    text: "None"
                };
            }

            function formatRepoSelection(repo) {
                return repo.full_name || repo.text;
            }

            const serialize = function (obj) {
                let str = [];
                obj = JSON.parse(obj);
                for (let p in obj)
                    if (obj.hasOwnProperty(p)) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    }
                return str.join(",");
            };

            const searchQuery = (scope.query) ? serialize(scope.query) : "";

            let displayFieldInput = scope.displayfield;
            let displayFieldFirst = scope.displayfield;
            let displayFieldsAll = [];

            if (displayFieldInput && displayFieldInput.toString().indexOf(',') > -1) {
                displayFieldsAll = displayFieldInput.split(',');
                displayFieldFirst = displayFieldsAll[0];
            }

            let _url = `/o/recs/${scope.collection}?stream=true&project=${displayFieldInput}&sort=${displayFieldFirst}&nd=${new Date().getTime()}`;

            const config = {
                width: 'resolve',
                placeholder: attributes.placeholder || "Select an option",
                ajax: {
                    url: _url,
                    dataType: 'json',
                    headers: {
                        "Authorization": 'Bearer ' + $localstorage.getObject("ob").token//$window.sessionStorage.token
                    },
                    delay: 250,
                    data: function (params) {
                        let searchTerm = {};
                        let multiKeySearch = '';

                        let userSearchTerm = "NOTEMPTY";
                        if (params.term) {
                            userSearchTerm = `*${params.term}`;
                        }
                        searchTerm["oquery"] = `${displayFieldFirst}=${userSearchTerm}`;

                        if (displayFieldsAll.length) {
                            multiKeySearch = '$or=';
                            for (let value of displayFieldsAll) {
                                multiKeySearch += `${value}=${userSearchTerm}^`
                            }
                            multiKeySearch = multiKeySearch.slice(0, -1);
                            searchTerm["oquery"] = multiKeySearch;
                        }

                        if (searchQuery) {
                            searchTerm["oquery"] += searchQuery;
                        }

                        if ($rootScope.ob.eduCollections && $rootScope.ob.eduCollections.includes(scope.collection)) {
                            searchTerm["oquery"] += `,session=${$localstorage.getObject("ob.edu").session || $rootScope.ob.session},domain=INedu:${$rootScope.ob.domain}`;
                        }
                        return searchTerm;
                    },
                    processResults: function (data, params) {
                        // parse the results into the format expected by Select2
                        // since we are using custom formatting functions we do not need to
                        // alter the remote JSON data, except to indicate that infinite
                        // scrolling can be used

                        const select2Data = data.map((obj) => {
                            obj.id = obj._id;
                            let text = obj[displayFieldFirst || "name"];
                            if (displayFieldsAll.length) {
                                text = '';
                                for (let field of displayFieldsAll) {
                                    try {
                                        if (field.indexOf('.') > -1) {
                                            let splitKeys = field.split('.');
                                            text += `${obj[splitKeys[0]][splitKeys[1]]}-`
                                        } else {
                                            text += `${obj[field]}-`
                                        }
                                    } catch (e) {
                                        text += `${obj[field]}-`
                                    }
                                }
                                text = text.slice(0, -1);
                            }
                            obj.text = text;
                            return obj;
                        });

                        select2Data.unshift({
                            id: '',
                            text: 'None'
                        });

                        params.page = params.page || 1;
                        return {
                            results: select2Data, //[{id: "1", text:"a1"}, {id: "2", text: "a2"}],
                            pagination: {
                                more: (params.page * 10) < data.total_count
                            }
                        };
                    },
                    cache: true
                },
                //escapeMarkup: function (markup) {
                //    return markup;
                //}//, // let our custom formatter work
                // minimumInputLength: 1//,
                //templateResult: formatRepo, // omitted for brevity, see the source of this page
                //templateSelection: formatRepoSelection // omitted for brevity, see the source of this page
            };

            const configSimple = {
                width: 'resolve',
                placeholder: attributes.placeholder || "Select an option"
            };

            const arrayEquals = (a, b) => {
                return Array.isArray(a) &&
                    Array.isArray(b) &&
                    a.length === b.length &&
                    a.every((val, index) => val === b[index]);
            }

            scope.select2Initialized = false;

            const initialize = (dataObject) => {
                $timeout(() => {

                    try {
                        element.select2('destroy');
                    } catch (e) {
                        // console.error(e);
                    }

                    try {
                        if (scope.inputType === "gselect" || scope.inputType === "mselect" || scope.inputType === "dataset" || (scope.inputType === "option" && scope.collection)) {
                            element.select2(config);
                        }
                        if (scope.inputType === "option" && !scope.collection) {
                            element.select2(configSimple);
                        }
                        scope.select2Initialized = true;
                        console.log('Intial setup..');
                        execute(dataObject);
                    } catch (e) {
                        console.error(e);
                    }
                });
            }

            const execute = (data) => {
                console.log('Setting data..', data);
                try {
                    if (scope.inputType === "gselect") {
                        if (scope.gselectValue[attributes.name] && !isMultiple) {
                            element.append('<option value="' + data.val.value + '" selected="selected">' + data.val.label + '</option>');
                        }

                        if (typeof data.val === "undefined" || data.val === "") {
                            element.append('<option value="" selected="selected">None</option>');
                        }

                        if (isMultiple) {
                            if (data.val) {
                                data.val.toString().split(",").map((val) => {
                                    val && element.append('<option value="' + val + '" selected="selected">' + val + '</option>');
                                })
                            }
                        }

                        element.bind("change", function () {
                            if (isMultiple) {
                                var txt = [];
                                var all_data = element.select2('data');
                                for (var k in element.select2('data')) {
                                    all_data[k].text && txt.push(all_data[k].text);
                                }
                                ngModel.$setViewValue(txt);
                            }

                            if (scope.gselectValue[attributes.name] && !isMultiple) {
                                scope.gselectValue[attributes.name] = {};
                                scope.gselectValue[attributes.name].label = element.select2('data')[0].text;
                                scope.gselectValue[attributes.name].value = element.select2('data')[0].id;
                                ngModel.$setViewValue(scope.gselectValue[attributes.name]);
                            }
                        });

                    }

                    if (scope.inputType === "mselect") {

                        element.bind("change", function () {
                            console.log('element changed', element, element.select2('data'))
                            if (isMultiple) {
                                const txt = [];
                                const all_data = element.select2('data');
                                for (var k in all_data) {
                                    if (all_data[k].text && !txt.includes(all_data[k].text)) {
                                        txt.push(all_data[k].text);
                                    }
                                }
                                ngModel.$setViewValue(txt);
                            }
                        });

                    }

                    if (scope.inputType === "option" && scope.collection) {
                        element.bind("change", function () {
                            const elData = element.select2('data')[0].text;
                            // console.log('element data - ', elData);
                            ngModel.$setViewValue(elData);
                        });

                        if (data.val) {
                            element.append('<option value="' + data.val + '" selected="selected">' + data.val + '</option>');
                        }
                    }

                    if (scope.inputType === "dataset" && scope.collection) {
                        element.change(function () {
                            let elData = element.select2('data')[0].id;
                            ngModel.$setViewValue(elData);
                        });

                        if (data.val) {
                            let elData = element.select2('data')[0].id;
                            element.append('<option value="' + elData + '" selected="selected">' + data.val + '</option>');
                        }
                    }

                    if (scope.inputType === "option" && !scope.collection) {

                        element.change(function () {
                            // console.log('insideChange', element.select2('data'));
                            const elData = element.select2('data')[0].id;
                            let setValue = elData;
                            if (elData && elData.indexOf(':') > -1) {
                                setValue = elData.split(':')[1];
                            }
                            ngModel.$setViewValue(setValue);
                        });

                        if (data.val) {
                            console.log('Finalizing..', data);
                            element.select2('data', data.val);
                            console.log('insideSetter', element.select2('data'));
                        }
                    }

                } catch (e) {
                    // throw e;
                    console.error(e);
                }
            }

            initialize({ val: '' });

            ngModel.$parsers.unshift(function (val) {
                return val;
            });

            ngModel.$formatters.push(function (val) {
                let returnval = val;
                let _val = val;
                if (scope.collection && scope.inputType === "gselect" && typeof val === "object" && Object.keys(val).indexOf('label') > -1) {
                    scope.gselectValue[attributes.name].text = val.label;
                    scope.gselectValue[attributes.name].id = val.value;
                    returnval = _val.value;
                } else if (isMultiple && val) {
                    _val = val.toString().split(",");
                    returnval = val;
                }
                if (typeof val === "undefined" || val === "" || val === null) {
                    _val = "";
                    returnval = _val;
                    return returnval;
                }
                console.log('Setting value..', _val, scope.inputType, scope.collection, attributes.name);
                initialize({ val: _val });
                return returnval;
            });

            // element.removeAttr('smart-select2 data-smart-select2');
        }
    };
}]);

obto.directive('conditionBuilder', ['$http', '$rootScope', '$compile', ($http, $rootScope, $compile) => {
    return {
        replace: true,
        restrict: 'E',
        require: 'ngModel',
        scope: {
            fieldValues: "@",
            modifiedFieldValue: "=",
            fieldName: "@"
        },
        templateUrl: $rootScope.viewFiles + '/condition-builder.html',
        link: async ($scope, element, attrs, ngModel) => {

            const setQueryBuilderInputType = (filter, _field, dropDownValues) => {
                if (_field.input_type === 'date') {
                    filter.type = 'date';
                    filter.validation = {
                        format: 'YYYY/MM/DD'
                    };
                    filter.plugin = 'datepicker',
                        filter.plugin_config = {
                            format: 'yyyy/mm/dd',
                            todayBtn: 'linked',
                            todayHighlight: true,
                            autoclose: true
                        };
                } else if (_field.input_type === 'datetime') {
                    filter.type = 'date';
                    filter.validation = {
                        format: 'YYYY/MM/DD'
                    };
                    filter.plugin = 'datepicker',
                        filter.plugin_config = {
                            format: 'yyyy/mm/dd',
                            todayBtn: 'linked',
                            todayHighlight: true,
                            autoclose: true
                        }
                } else if (_field.input_type === 'decimal') {
                    filter.input = 'number';
                    filter.type = 'double';
                } else if (['document_editor', 'tarea'].includes(_field.input_type)) {
                    filter.input = 'textarea';
                } else if (_field.input_type === 'checkbox') {
                    filter.input = 'checkbox';
                    filter.values = {
                        true: 'True',
                        false: 'False'
                    };
                    filter.color = 'primary';
                    //filter.plugin = 'bt-checkbox';
                } else if (_field.input_type === 'mselect') {
                    filter.input = 'select';
                    filter.plugin = 'select2';
                    filter.values = [...dropDownValues];
                } else if (_field.input_type === 'option') {
                    // filter.input = 'select';
                    filter.valueSetter = function (rule, value) { };
                    filter.plugin = 'select2';
                    filter.plugin_config = {
                        data: ["abc", "xyz"],
                        width: 'resolve',
                        placeholder: "Select an option"
                    };
                    filter.values = [...dropDownValues];
                } else if (_field.input_type === 'gselect') {
                    filter.plugin = 'autocomplete';
                    filter.plugin_config = {
                        source: function (query, callback) {
                            // console.log(query);
                            $.ajax({
                                url: `/o/recs/${_field.refer_collection}?oquery=name=*${query.term},domain=${$rootScope.ob.domain}&stream=true&nd=${new Date().getTime()}`,
                                type: 'GET',
                                headers: {
                                    "Authorization": `Bearer ${$rootScope.token}`,
                                },
                                error: function () {
                                    callback();
                                },
                                success: function (data) {
                                    let arr = [];
                                    data.forEach((val) => {
                                        arr.push({
                                            value: val.id,
                                            label: val.name
                                        });
                                    });
                                    callback(arr);
                                }
                            });
                        },
                        select: function (event, ui) {
                            //$("#internationalFilters .queryBuilder")[0].queryBuilder.trigger("change");
                        }
                    }
                }
            };
            const builder = $(element[0]);

            const inputTypeOperatorMapping = {
                date: ['equal', 'not_equal', 'in', 'not_in', 'is_null', 'is_not_null', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between', 'not_between'],
                text: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                code: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                tarea: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                checkbox: ['equal', 'not_equal', 'in', 'not_in'],
                number: ['equal', 'not_equal', 'in', 'not_in', 'is_null', 'is_not_null', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between', 'not_between'],
                document_editor: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                url: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                option: ['equal', 'not_equal', 'in', 'not_in'],
                email: ['equal', 'not_equal', 'in', 'not_in', 'is_null', 'is_not_null', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                phone: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                password: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                radio: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                mselect: ['equal', 'not_equal', 'in', 'not_in'],
                gselect: ['equal', 'not_equal', 'in', 'not_in'],
                datetime: ['equal', 'not_equal', 'in', 'not_in', 'is_null', 'is_not_null', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between', 'not_between'],
                sequence: ['equal', 'not_equal', 'in', 'not_in', 'begins_with', 'not_begins_with', 'contains', 'not_contains', 'ends_with', 'not_ends_with', 'is_empty', 'is_not_empty'],
                decimal: ['equal', 'not_equal', 'in', 'not_in', 'is_null', 'is_not_null', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between', 'not_between'],
                image: ['equal', 'not_equal', 'in', 'not_in']
            };

            $scope.gridReady = false;
            $scope.filters = [];
            const values = typeof $scope.fieldValues === "string" ? JSON.parse($scope.fieldValues) : $scope.fieldValues;
            const queryCollection = values.table ? values.table : values.collection;

            let result = await $http.get(`/o/form/${queryCollection}/new`);
            let fieldsAdded = {};
            let dropDownValues = [];
            const allFields = result.data.fields;
            const options = result.data.option;
            if (allFields && allFields.length) {
                allFields.forEach((_field) => {
                    if (!fieldsAdded[_field.name]) {
                        fieldsAdded[_field.name] = true;
                    } else {
                        return;
                    }
                    dropDownValues = [];
                    options.forEach((option) => {
                        if (option.field === _field.name) {
                            dropDownValues.push({
                                value: option.id,
                                label: option.name
                            });
                        }
                    });
                    const filter = {
                        id: _field.name,
                        label: _field.label,
                        type: 'string',
                        operators: inputTypeOperatorMapping[_field.input_type]
                    };
                    setQueryBuilderInputType(filter, _field, dropDownValues);
                    $scope.filters.push(filter);
                });
            }


            $scope.destroyQueryBuilder = () => {
                if (builder) {
                    builder.queryBuilder('destroy');
                }
            };

            $scope.reset = function () {
                builder.queryBuilder('reset');
                $scope.jsonParsed = "";
                $scope.sqlParsed = "";
            };

            $scope.run = function () {
                // json
                const resJson = builder.queryBuilder('getMongo');
                const jsonStrigified = JSON.stringify(resJson);
                $scope.ngModel = jsonStrigified;//$setViewValue(
                ngModel.$setViewValue(jsonStrigified);
                $scope.modifiedFieldValue[$scope.fieldName] = jsonStrigified;
                $(".rules-group-body .glyphicon-warning-sign").css("display", "none");
                $(".rules-group-body .form-control").css("padding", "5px");

            };

            let rules;
            try {
                builder.queryBuilder({
                    sortable: true,
                    // plugins: ['bt-selectpicker'],
                    plugins: {
                        // 'bt-tooltip-errors': { delay: 100 },
                        // 'bt-selectpicker': null,
                        // 'sortable': null
                    },
                    filters: $scope.filters
                });
                builder.queryBuilder('reset');

                builder.on('afterUpdateRuleValue.queryBuilder', function (e, rule) {
                    var resJson = builder.queryBuilder('getMongo');
                    const jsonStrigified = JSON.stringify(resJson);
                    $scope.ngModel = jsonStrigified;//$setViewValue(
                    ngModel.$setViewValue(jsonStrigified);
                    // console.log("after", jsonStrigified);
                    $scope.modifiedFieldValue[$scope.fieldName] = jsonStrigified;
                    $(".rules-group-body .glyphicon-warning-sign").css("display", "none");
                    $(".rules-group-body .form-control").css("padding", "5px");
                });

                builder.on('afterReset.queryBuilder', function (e, rule) {
                    $scope.ngModel = "";//$setViewValue(
                    ngModel.$setViewValue("");
                    // console.log("afterReset");
                    $scope.modifiedFieldValue[$scope.fieldName] = "";
                    $(".rules-group-body .glyphicon-warning-sign").css("display", "none");
                    $(".rules-group-body .form-control").css("padding", "5px");
                });

                builder.on('afterUpdateRuleValue.queryOperator', function (e, rule) {
                    var resJson = builder.queryBuilder('getMongo');
                    const jsonStrigified = JSON.stringify(resJson);
                    $scope.ngModel = jsonStrigified;//$setViewValue(
                    ngModel.$setViewValue(jsonStrigified);
                    $scope.modifiedFieldValue[$scope.fieldName] = jsonStrigified;
                    // console.log("after2", jsonStrigified);
                    $(".rules-group-body .glyphicon-warning-sign").css("display", "none");
                    $(".rules-group-body .form-control").css("padding", "5px");
                });

                builder.on('afterUpdateRuleValue.queryFilter', function (e, rule) {
                    var resJson = builder.queryBuilder('getMongo');
                    const jsonStrigified = JSON.stringify(resJson);
                    $scope.ngModel = jsonStrigified;//$setViewValue(
                    ngModel.$setViewValue(jsonStrigified);
                    // console.log("after3", jsonStrigified);
                    $scope.modifiedFieldValue[$scope.fieldName] = jsonStrigified;
                    $(".rules-group-body .glyphicon-warning-sign").css("display", "none");
                    $(".rules-group-body .form-control").css("padding", "5px");
                });

            } catch (e) {
                console.log(e);
            }

            ngModel.$formatters.push(function (val) {
                // console.log(val)
                if (val && Object.keys(JSON.parse(val)).length) {
                    rules = JSON.parse(val);
                    // console.log("after5", rules);
                    builder.queryBuilder('setRulesFromMongo', rules);
                    $(".rules-group-body .glyphicon-warning-sign").css("display", "none");
                    $(".rules-group-body .form-control").css("padding", "5px");
                }
            });
        }
    };
}]);

obto.directive('widgetGrid', ['$rootScope', function ($rootScope) {

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            element.removeAttr('widget-grid data-widget-grid');
            $rootScope.$emit('jarvisWidgetAdded', element);

        }
    };
}]);

obto.directive('smartWizard', ['$rootScope', function ($rootScope) {
    return {
        restrict: 'A',
        scope: {
            'smartWizardCallback': '&'
        },
        link: function (scope, element, attributes) {

            var stepsCount = $('[data-smart-wizard-tab]', element).length;

            var currentStep = 1;

            var validSteps = [1, 2, 3, 4];

            var $form = element.closest('form');

            var $prev = $('[data-smart-wizard-prev]', element);

            var $next = $('[data-smart-wizard-next]', element);

            function setStep(step) {
                //currentStep = step;
                $('[data-smart-wizard-pane=' + step + ']', element).addClass('active').siblings('[data-smart-wizard-pane]').removeClass('active');
                $('[data-smart-wizard-tab=' + step + ']', element).addClass('active').siblings('[data-smart-wizard-tab]').removeClass('active');

                $prev.toggleClass('disabled', step == 1);
            }


            //element.on('click', '[data-smart-wizard-tab]', function (e) {
            //    setStep(parseInt($(this).data('smartWizardTab')));
            //    e.preventDefault();
            //});

            $next.on('click', function (e) {
                console.log("Step : " + currentStep + " : " + stepsCount);
                if ($form.data('validator')) {
                    if (!$form.valid()) {
                        validSteps = _.without(validSteps, currentStep);
                        $form.data('validator').focusInvalid();
                        return false;
                    } else {
                        validSteps = _.without(validSteps, currentStep);
                        validSteps.push(currentStep);
                        element.find('[data-smart-wizard-tab=' + currentStep + ']')
                            .addClass('complete')
                            .find('.step')
                            .html('<i class="fa fa-check"></i>');
                        currentStep++;
                        setStep(currentStep);
                        if (currentStep < stepsCount) {
                            $next.html('<button class="btn btn-lg btn-default obto-wizard-button-right"> Next </button>');
                        }
                        if (currentStep === stepsCount) {
                            $next.html('<button class="btn btn-lg btn-default obto-wizard-button-right"> Complete </button>');
                        }
                        if (currentStep > stepsCount) {
                            $next.toggleClass('disabled', true);
                            $next.html('<button disabled class="btn btn-lg btn-default obto-wizard-button-right"> Closed </button>');
                            var data = {};
                            _.each($form.serializeArray(), function (field) {
                                data[field.name] = field.value;
                            });
                            if (typeof scope.smartWizardCallback() === 'function') {
                                scope.smartWizardCallback()(data);
                            }
                        }
                    }
                }

                e.preventDefault();
            });

            $prev.on('click', function (e) {
                //console.log("Previous : " + currentStep);
                if (!$prev.hasClass('disabled') && currentStep > stepsCount) {
                    currentStep--;
                }
                if (!$prev.hasClass('disabled') && currentStep > 0) {
                    currentStep--;

                    if (currentStep < stepsCount) {
                        $next.html('<button class="btn btn-lg btn-default obto-wizard-button-right"> Next </button>');
                    }

                    setStep(currentStep);
                }
                e.preventDefault();
            });


            setStep(currentStep);

            $rootScope.$on('movenextwizard', function (event, data) {
                //console.log(JSON.stringify(data));
                currentStep++;
                setStep(data);
            });

            $rootScope.$on('event:movetostepwizard', function (event, data) {
                //console.log(JSON.stringify(data));
                $next.html('<button class="btn btn-lg btn-default obto-wizard-button-right"> Complete </button>');
                $prev.toggleClass('disabled', false);
                currentStep = data;
                setStep(data);
            });

            $rootScope.$on('resetwizard', function (event, data) {
                //console.log(JSON.stringify(data));
                currentStep = 1;
                setStep(currentStep);
            });

        }
    };
}]);

obto.directive('smartValidateForm', function () {
    return {
        restrict: 'A',
        link: function (scope, form, attributes) {


            var validateOptions = {
                rules: scope.rules || {},
                messages: {},
                highlight: function (element) {
                    $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
                },
                unhighlight: function (element) {
                    $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
                },
                errorElement: 'span',
                errorClass: 'help-block',
                errorPlacement: function (error, element) {
                    if (element.parent('.input-group').length) {
                        error.insertAfter(element.parent());
                    } else {
                        error.insertAfter(element);
                    }
                }
            };
            form.find('[data-smart-validate-input], [smart-validate-input]').each(function () {
                var $input = $(this),
                    fieldName = $input.attr('name');

                // validateOptions.rules[fieldName] = {};
                if (!validateOptions.rules[fieldName])
                    validateOptions.rules[fieldName] = {};

                if ($input.data('required') !== undefined) {
                    validateOptions.rules[fieldName].required = true;
                }
                if ($input.data('email') !== undefined) {
                    validateOptions.rules[fieldName].email = true;
                }

                if ($input.data('maxlength') !== undefined) {
                    validateOptions.rules[fieldName].maxlength = $input.data('maxlength');
                }

                if ($input.data('minlength') !== undefined) {
                    validateOptions.rules[fieldName].minlength = $input.data('minlength');
                }

                if ($input.data('message')) {
                    validateOptions.messages[fieldName] = $input.data('message');
                } else {
                    angular.forEach($input.data(), function (value, key) {
                        if (key.search(/message/) === 0) {
                            if (!validateOptions.messages[fieldName])
                                validateOptions.messages[fieldName] = {};

                            var messageKey = key.toLowerCase().replace(/^message/, '');
                            validateOptions.messages[fieldName][messageKey] = value;
                        }
                    });
                }
            });

            // console.log(validateOptions);
            form.validate(validateOptions);

        }
    };
});

obto.directive("obCe", function () {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {

            function read() {
                ngModel.$setViewValue(element.html());

            }

            var _id = attrs.document;
            var collection = attrs.collection;
            var key = attrs.key;

            // console.log(attrs);

            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    //console.log("Saving value to database" + ngModel.$viewValue + ":" + element.html())
                    ngModel.$setViewValue(element.html());
                    element.removeClass("obto-contenteditable");
                    event.preventDefault();
                }
            });

            element.bind("click", function (e) {
                element.addClass("obto-contenteditable");
            });

            ngModel.$render = function () {
                element.html(ngModel.$viewValue || "");
            };

            element.bind("blur", function () {
                scope.$digest(read);
            });
        }
    };
});

obto.directive('wizard', ['$compile', function ($compile) {
    return {
        restrict: 'EA',
        scope: {
            stepChanging: '=',
            stepChanged: '=',
            onFinishing: '=',
            onFinished: '=',
            init: "="
        },
        compile: function (element, attr) {
            // element.show().steps(attr.config).validate(attr.validation);
            // console.log(attr);
            let config = {
                bodyTag: attr.bodyTag || "section",
                headerTag: attr.headerTag || "h3",
                transitionEffect: "slideLeft"
            };
            element.steps(config);
            return {
                //pre-link
                pre: function (scope, element) {

                },
                //post-link
                post: function (scope, element) {
                    // console.log(scope.stepChanging);
                    element.on('init', scope.init);
                    element.on('stepChanging', scope.stepChanging);
                    element.on('stepChanged', scope.stepChanged);
                    element.on('finishing', scope.onFinishing);
                    element.on('finished', scope.onFinished);
                }
            };
        }
    };
}]);

obto.directive('toggleMenu', function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            var $body = $('body');

            var toggleMenu = function () {
                if (!$body.hasClass("menu-on-top")) {
                    $('html').toggleClass("hidden-menu-mobile-lock");
                    $body.toggleClass("hidden-menu");
                    $body.removeClass("minified");
                } else if ($body.hasClass("menu-on-top") && $body.hasClass("mobile-view-activated")) {
                    $('html').toggleClass("hidden-menu-mobile-lock");
                    $body.toggleClass("hidden-menu");
                    $body.removeClass("minified");
                }
            };

            element.on('click', toggleMenu);

            $('.left-menu-toggle').on('click', function () {
                $(this).toggleClass('active');
                $('nav.left-menu').toggleClass('left-menu-showed');
                $('nav.top-menu').toggleClass('ob-left-nav-adjust');
                $('.main-backdrop').toggleClass('main-backdrop-showed');
            });

            scope.$on('requestToggleMenu', function () {
                toggleMenu();
            });
        }
    };
});

obto.directive('resetWidgets', function () {

    return {
        restrict: 'A',
        link: function (scope, element) {
            element.on('click', function () {
                $.SmartMessageBox({
                    title: "<i class='fa fa-refresh' style='color:green'></i> Clear Local Storage",
                    content: "Would you like to RESET all your saved widgets and clear LocalStorage?1",
                    buttons: '[No][Yes]'
                }, function (ButtonPressed) {
                    if (ButtonPressed === "Yes" && localStorage) {
                        localStorage.clear();
                        location.reload();
                    }
                });

            });
        }
    };

});

obto.directive('reactComponent', ['$compile', '$rootScope', 'ScriptLoader', function ($compile, $rootScope, ScriptLoader) {
    return {
        scope: {
            component: '=',
            name: "@",
            input: "<",
            callback: "&"
        },
        link: function (scope, element, attrs) {
            let root;
            let name = '';
            let component = {
                reference: ""
            };

            if (typeof scope.name !== "undefined") {
                name = scope.name.trim();
                ScriptLoader.load().then((CS) => {
                    component.reference = CS[scope.name.trim()];
                    // console.log(scope.name, component.reference);
                    if (typeof component.reference !== "undefined") {
                        return linkDirective();
                    } else {
                        console.log(`Problem with RC ${scope.name}`);
                    }
                });
            }
            
            typeof scope.name === "undefined" && scope.$watch('component', function (newVal, oldVal) {
                if (typeof newVal !== "undefined") {
                    // Call the re-linking function
                    ScriptLoader.load().then((CS) => {
                        component.reference = scope.component
                        linkDirective();
                    });
                }
            });

            // const linkDirective = () => {
            //     if (typeof component.reference === "undefined" || typeof component.reference === "string") {
            //         return;
            //     }

            //     if (typeof scope.callback === "undefined") {
            //         scope.callback = () => { };
            //     }

            //     if (typeof scope.input === "undefined") {
            //         scope.input = {};
            //     }

            //     const _callback = (key) => {
            //         scope.callback(key)
            //     }

            //     const reactComponentRef = React.createRef();
            //     if (!root) {
            //         root = createRoot(element[0]);
            //         root.render(<Provider store={store}><DynamicComponent name={name} componentRef={component.reference} props={{ rootscope: $rootScope, input: scope.input }}></DynamicComponent></Provider>);
            //     }

            //     if (reactComponentRef.current) {
            //         reactComponentRef.current.updateState(true);
            //     }
            // }
            const linkDirective = () => {
                if (typeof component.reference === "undefined" || typeof component.reference === "string") {
                    return;
                }

                if (typeof scope.callback === "undefined") {
                    scope.callback = () => { };
                }

                if (typeof scope.input === "undefined") {
                    scope.input = {};
                }

                const _callback = (key) => {
                    scope.callback(key);
                }

                // Render function that can be called multiple times
                const renderReactComponent = () => {
                    if (!root) {
                        root = createRoot(element[0]);
                    }

                    root.render(
                        <Provider store={store}>
                            <DynamicComponent
                                name={name}
                                componentRef={component.reference}
                                props={{
                                    rootscope: $rootScope,
                                    input: scope.input  // ← Fresh input on every render
                                }}
                            />
                        </Provider>
                    );
                };

                // Initial render
                renderReactComponent();

                // Watch for input changes and re-render React component
                scope.$watch('input', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        renderReactComponent();
                    }
                }, true);  // ← 'true' enables deep watching for object properties
            }

            scope.$on('$destroy', function () {
                if (root) {
                    root.unmount();
                    root = null;
                }
            });
        }
    };
}]);

obto.directive('navItems', ["$rootScope", "$localstorage", "$timeout", "$http", "$ngRedux", ($rootScope, $localstorage, $timeout, $http, $ngRedux) => {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            const renderNavMenu = (apps, subapps) => {
                // debugger;
                // console.log('initNav...5');
                apps.forEach((item) => {
                    item.items = _.where(subapps, { "application": item.name });
                });
                const root = createRoot(element[0]);
                const reactComponentRef = React.createRef();
                root.render(<Provider store={store}><NavigationComponent rootScope={$rootScope} input={{
                    logo: $rootScope.ob.logourl
                }} apps={apps} /></Provider>);
            };

            const initNav = () => {
                console.log('initNav...');
                let apps = [];
                let subapps = [];
                let lastOpenedCollection = "";

                const getApps = (c) => {
                    const step = 1;
                    $http.get(attrs.navItems).then((res) => {
                        apps = res.data;
                        c(null, step);
                    });
                };

                const getSubApps = (c) => {
                    const step = 2;
                    $http.get(`/o/recs/pltf_navigation?nd=${new Date().getTime()}&oquery=active=true&stream=true&project=title,table,type,application,order,_id,domain,argument,role`).then((res) => {
                        subapps = res.data;
                        c(null, step);
                    });
                };

                let existingApps = $localstorage.getObject("obto.apps");
                const existingUser = $localstorage.getObject("obto.user_name");
                if (existingUser.user_name !== $rootScope.ob.user.username) {
                    existingApps = null;
                }

                const leftSideNav = document.getElementById('side-menu');
                if (leftSideNav) {
                    leftSideNav.style.width = '240px';
                    // Optional: Add transition
                    leftSideNav.style.transition = 'margin-left 0.2s';
                }

                if (Array.isArray(existingApps) && existingApps.length && $rootScope.ob.socketSecured) {
                    $timeout(() => {
                        // $rootScope.$broadcast('nav.ready', {});
                        apps = $localstorage.getObject("obto.apps");
                        subapps = $localstorage.getObject("obto.subapps");
                        // console.log('initNav...1');
                        renderNavMenu(apps, subapps);
                        // console.log('initNav...2');
                    }, 100);
                } else {
                    async.parallel([getApps, getSubApps], (err, done) => {
                        $localstorage.setObject("obto.apps", apps);
                        $localstorage.setObject("obto.subapps", subapps);
                        // console.log('initNav...3');
                        $timeout(() => {
                            $localstorage.setObject("obto.apps", apps);
                            $localstorage.setObject("obto.subapps", subapps);
                            // console.log('initNav...4');
                            // $rootScope.$broadcast('nav.ready', {});
                            renderNavMenu(apps, subapps);
                        }, 100);
                    });
                }
            };

            // Check if already logged in to handle cases where event was broadcasted before directive initialization
            if (!$rootScope.ob.isLoginOpen) {
                initNav();
            }

            // Listen to login events as well
            $rootScope.$on('event:loginConfirmed', initNav);
            $rootScope.$on('event:loggedIn', initNav);

            $ngRedux.subscribe(function () {
                let state = $ngRedux.getState();
                NProgress.done();
                if (state.login) {
                    if (state.login.loginStatus === 0) {
                        initNav();
                    }
                }
            });
        }
    };
}]);

obto.directive('dropZone', ['$rootScope', '$routeParams', '_', '$window', '$localstorage', 'API', '$log', function ($rootScope, $routeParams, _, $window, $localstorage, API, $log) {

    return {
        scope: {
            collection: '@',
            tags: '@',
            localstore: '=',
            custom: '=',
            currentTab: '=',
            document: '@',
            process: '@',
            existingFiles: '=',
            acceptedFiles: '@',
            allowedSize: '@',
            uploadValidation: '=',
            response: "=",
            album: '@',
            description: '@',
            title: '@',
            uploadincollection: '@'
        },
        link: function (scope, element, attrs) {

            let COLLECTION = scope.collection;
            let acceptedFiles = scope.acceptedFiles || ".csv,.json,.xls,.xlsx,.doc,.docx,.pdf,.css";
            let thisDropzone = undefined;
            let LOCALSTORE = false;
            let CUSTOM = false;
            let ALBUMName = "";
            scope.tmap = null;
            let ALBUM = false;
            // let PATH = scope.customUrl;

            if (typeof scope.localstore !== "undefined") {
                LOCALSTORE = true;
                acceptedFiles += ",.png,.jpeg,.jpg,.gif,.ico,.JPG,.PNG,.GIF,.ICO,.mp4,.mp3";
            }

            if (typeof scope.album !== "undefined") {
                ALBUM = true;
                ALBUMName = scope.album;
                CUSTOM = false;
                scope.process = false;
                LOCALSTORE = false;
            }

            if (typeof scope.custom !== "undefined") {
                CUSTOM = true;
            }

            if (typeof scope.description === "undefined") {
                scope.description = "";
            }

            if (!COLLECTION) {
                COLLECTION = $routeParams.collection || "fs.files";
            }

            if (COLLECTION === 'image' || CUSTOM || ALBUM) {
                acceptedFiles = ".png,.jpeg,.jpg,.gif,.ico,.JPG,.PNG,.GIF,.ICO";
            }

            if (typeof scope.existingFiles === 'undefined') {
                scope.existingFiles = {};
            }

            $log.debug(acceptedFiles);

            element.dropzone({
                url: "/o/uploadfile.bto",
                maxFilesize: parseInt(scope.allowedSize) || 100,
                paramName: "file",
                acceptedFiles: acceptedFiles,
                maxThumbnailFilesize: 5,
                addRemoveLinks: true,
                parallelUploads: 5,
                dictResponseError: "Error uploading file!",
                headers: {
                    "Authorization": 'Bearer ' + $localstorage.getObject("ob").token,
                    "Instance-Edu": $rootScope.ob.isEdu,
                    "Current-Domain": $rootScope.ob.domain,
                    "Current-Session": $rootScope.ob.session
                },
                init: function () {
                    thisDropzone = this;

                    this.on('success', function (file, response) {

                        _.extend(scope.response, response);

                        if (response.hasOwnProperty("success") && response.success) {
                            let key = response.record._id;
                            scope.existingFiles[key] = {
                                "name": response.filename,
                                "size": file.size,
                                "type": response.record.contentType,
                                "link": "/o/pltf_file_store/" + response.record._id,
                                "_id": response.record._id
                            };
                            file._id = key;
                            $rootScope.$emit("event:file:uploaded:" + COLLECTION, {
                                response
                            });
                            return;
                        }

                        if (response.hasOwnProperty("message") && response.message) {
                            $rootScope.$emit("event:file:uploaded:" + COLLECTION, {
                                response
                            });
                            return;
                        }

                        $rootScope.$emit("event:file:upload:failed" + COLLECTION, {
                            response
                        });
                    });

                    this.on("processing", function (file) {

                    });

                    this.on("sending", function (file, xhr, data) {
                        data.append("_csrf", $rootScope._csrf);
                        data.append("collection", COLLECTION);
                        data.append("uploadincollection", scope.uploadincollection || false);
                        data.append("fname", file.name);
                        data.append("document", scope.document || 'obto.default');
                        data.append("tag", scope.tags);
                        data.append("fsize", file.size || 0);
                        data.append("album", scope.album || '');
                        data.append("tmap", scope.tmap || '');
                        data.append("description", scope.description || '');
                        data.append("title", scope.title || '');
                    });

                    if (!scope.existingFiles) {
                        return;
                    }

                    _.each(scope.existingFiles, function (value, key, list) {
                        let mockFile = { name: value.name, size: value.size, type: value.type, _id: value._id };
                        thisDropzone.options.addedfile.call(thisDropzone, mockFile);
                        thisDropzone.options.thumbnail.call(thisDropzone, mockFile, value.link);
                    });

                },
                removedfile: function (file) {
                    $log.info(file);
                    let key = file._id;
                    $.ajax({
                        type: 'POST',
                        url: '/o/trash.bto',
                        headers: {
                            "Authorization": 'Bearer ' + $localstorage.getObject("ob").token//$window.sessionStorage.token
                        },
                        data: {
                            id: key,
                            _csrf: $rootScope._csrf
                        },
                        dataType: 'json'
                    });
                    try {
                        delete scope.existingFiles[key];
                    } catch (e) {
                        console.log(e);
                    }
                    let _ref;
                    return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
                },
                uploadprogress: function (file, progress, bytesSent) {
                    // if (file.previewElement) {
                    //     var progressElement = file.previewElement.querySelector("[data-dz-uploadprogress]");
                    //     progressElement.style.width = progress + "%";
                    //     progressElement.querySelector(".progress-text").textContent = progress + "%";
                    // }
                },
                accept: function (file, done) {

                    const ext = file.name.substr(file.name.lastIndexOf('.'));
                    $log.info('scope.currentTab', scope.currentTab);
                    $log.debug($routeParams);
                    // $log.debug(scope.customUrl);
                    $log.info($routeParams);
                    $log.debug(typeof CUSTOM);
                    $log.debug(CUSTOM);

                    if (ext && ext.match(/\.exe|\.sh|\.dmg/)) {
                        swal({
                            type: 'error',
                            title: 'Oops...',
                            text: 'File type not allowed'
                        });
                        return done("File type not allowed");
                    }

                    if (scope.currentTab === 'cdn' && !scope.tags) {
                        swal('Error', 'Please select a path', 'error');
                        return done('Path cannot be empty');
                    }

                    if (COLLECTION !== "fs.files" && ext && ext.match(/\.json/)) {
                        this.options.url = "/o/uploadjson.bto/" + COLLECTION;
                        return done();
                    }

                    if (scope.process && ext && (ext.match(/\.xlsx/) || ext.match(/\.xls/)) && COLLECTION !== "fs.files") {
                        this.options.url = "/o/uploadexcel.bto/" + COLLECTION;
                        return done();
                    }

                    if (scope.process && ext && ext.match(/\.csv/) && COLLECTION !== "fs.files") {
                        let mapCollection = document.createElement("select");
                        mapCollection.id = "transformaps";

                        return API("transform").query({
                            oquery: "active=true,collection=" + (COLLECTION || $routeParams.collection),
                            stream: true,
                            sort: "name",
                            project: "name,_id,field_map,template"
                        }).$promise.then((maps) => {
                            let allMaps = {};
                            let allMapsNormalized = {};
                            _.map(maps, function (val, key) {
                                allMaps[val._id] = val.name;
                                allMapsNormalized[val._id] = val;
                            });

                            allMaps['default'] = 'Default';

                            swal({
                                title: 'Select Transform Map',
                                input: 'select',
                                inputOptions: allMaps,
                                inputPlaceholder: 'required',
                                showCancelButton: true,
                                inputValidator: (value) => {
                                    return new Promise((resolve, reject) => {
                                        if (value !== '') {
                                            resolve();
                                        } else {
                                            reject('You need to select a Tier');
                                        }
                                    });
                                }
                            }).then((result) => {

                                if (!result.value) {
                                    console.log(result);
                                    throw new Error("Transform Map cannot be emtpy");
                                }

                                swal({
                                    type: 'success',
                                    html: 'Processing file now.....'
                                });
                                console.log("Moving...");
                                scope.tmap = result.value;
                                const fields = allMapsNormalized[result.value].field_map;
                                this.options.url = "/o/uploaddata.bto/" + COLLECTION;
                                // console.log(this.options.url);

                                PapaParser.parse(file, {
                                    complete: function (results, file) {
                                        // const problemFields = results.data[0].filter(value => !(JSON.parse(fields).includes(value)));
                                        const problemFields = JSON.parse(fields).filter(value => !(results.data[0].includes(value)));
                                        console.log("Parsing complete:", results.data[0], JSON.parse(fields), problemFields);
                                        if (problemFields.length === 0) {
                                            done();
                                        } else {
                                            scope.uploadValidation.user_fields = results.data[0];
                                            scope.uploadValidation.template_fields = JSON.parse(fields);
                                            scope.uploadValidation.template = allMapsNormalized[result.value].template;
                                            scope.uploadValidation.problemFields = problemFields;
                                            scope.$applyAsync();
                                            swal({
                                                type: 'error',
                                                html: 'Field Mismatch'
                                            });
                                            feather.replace({
                                                width: 18,
                                                height: 18,
                                            });
                                            done("Field Mismatch");
                                        }
                                    }
                                });
                                // done();
                            }).catch((error) => {
                                swal({
                                    type: 'error',
                                    html: 'Please select a transform map to proceed.'
                                });
                                done("Transform Map cannot be emtpy.");
                            });
                        });
                    }


                    if (CUSTOM && ext && ext.match(/\.jpg|\.jpeg|\.png|\.ico|\.ICO|\.PNG|\.JPG|\.JPEG/)) {
                        this.options.url = "/imageupload.bto";
                        return done();
                    }

                    if (COLLECTION === "image" && ext && ext.match(/\.jpg|\.jpeg|\.png|\.ico|\.ICO|\.PNG|\.JPG|\.JPEG/)) {
                        this.options.url = "/imageupload.bto";
                        return done();
                    }

                    if (ALBUM && ext && ext.match(/\.jpg|\.jpeg|\.png|\.ico|\.ICO|\.PNG|\.JPG|\.JPEG/)) {
                        this.options.url = "/albumupload.bto";
                        return done();
                    }

                    if (ext && scope.uploadincollection && !ext.match(/\.css/) && COLLECTION === "pltf_stylesheet") {
                        return done();
                    }

                    if (ext && scope.uploadincollection && !ext.match(/\.js/) && COLLECTION === "pltf_javascript") {
                        return done();
                    }


                    if (ext && !ext.match(/\.csv|\.xls|\.xlsx|\.doc|\.docx|\.pdf|\.json|\.jpg|\.jpeg|\.png|\.ico|\.ICO|\.PNG|\.JPG|\.JPEG|\.mp4|\.mp3|\.js|\.css/)) {
                        return done("File type not allowed");
                    }

                    file.acceptDimensions = done;
                    file.rejectDimensions = function () {
                        done("Image too small.");
                    };

                    done();
                }

            });

            scope.$watch("existingFiles", function (n, o) {
                if (thisDropzone && 0 !== Object.keys(n).length && Object.keys(o).length !== Object.keys(n).length) {
                    // thisDropzone.removeAllFiles(true);
                    _.each(n, function (value, key, list) {
                        let mockFile = {
                            name: value.name,
                            size: value.size,
                            type: value.type,
                            _id: value._id,
                            url: value.link
                        };
                        thisDropzone.emit("addedfile", mockFile);
                        thisDropzone.emit("thumbnail", mockFile, value.link);
                        thisDropzone.createThumbnailFromUrl(value, value.link);
                        thisDropzone.emit("complete", mockFile);
                    });
                }
            }, true);
        }
    };

}]);

obto.directive('compile', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
        scope.$watch(
            function (scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            },
            function (value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
            }
        );
    };
}]);

obto.directive('compilev2', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
        scope.$watch(
            function (scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compilev2);
            },
            function (value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                // element.html(value);
                // console.log(element.contents());
                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                // console.log(value);
                let linkingFunction = $compile(value);
                // console.log(linkingFunction);
                let _element = linkingFunction(scope);
                // console.log(_element);
                element.replaceWith(_element);

            }
        );
    };
}]);

obto.directive('obtoScript', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        terminal: true,
        compile: function (element, attr) {
            if (attr.type === 'text/ng-template') {
                attr.style = "display : none;";
                var templateUrl = attr.id,
                    text = element[0].innerHTML;

                $templateCache.put(templateUrl, text);
            }
        }
    };
}]);

obto.directive('setNgAnimate', ['$animate', function ($animate) {
    return {
        link: function ($scope, $element, $attrs) {

            $scope.$watch(function () {
                return $scope.$eval($attrs.setNgAnimate, $scope);
            }, function (valnew, valold) {
                $animate.enabled(!!valnew, $element);
            });


        }
    };
}]);

obto.directive('confirmOnExit', function () {
    return {
        link: function ($scope, elem, attrs) {

            window.onbeforeunload = function () {
                try {
                    if ($scope.obtoform.$dirty) {
                        return "The form has been modified, do you want to leave this page?";
                    }
                    // $(".overlay").show();
                } catch (e) {

                }
            };
            const deregister = $scope.$on('$locationChangeStart', function (event, next, current) {
                try {
                    if ($scope.obtoform.$dirty) {
                        if (!confirm("The form has changed, do you want to leave this page?")) {

                            // NProgress End
                            // setTimeout(function () {
                            NProgress.done();
                            bodySelector.removeClass('initial-hide');
                            // }, 1000);
                            bodySelector.removeClass('cui-page-loading-state');
                            event.preventDefault();
                        }
                    }
                } catch (e) {

                }
            });

            $scope.$on('$destroy', () => {
                deregister();
            });

        }
    };
});

obto.directive('obtoChart', ['$compile', 'pageService', '$timeout', '$http', ($compile, pageService, $timeout, $http) => {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            visual: '@'
        },
        transclude: true,
        link: function (scope, element, attributes) {
            // console.log('attributes', attributes);
            const visualID = scope.visual;
            const injectLoaderElement = '<span id="loader-{{widget.id}}" class="spinner-grow" style="width: 6rem; height: 6rem;" role="status">\n' +
                '  <span class="sr-only">Loading...</span>\n' +
                '</span>';

            const injectWidgetElement = '<highchart id="chart-{{widget.id}}"\n' +
                'config="widget.config"\n' +
                'style="height: {{widget.height}}; width: {{widget.width}};">\n' +
                '</highchart>';

            scope.widget = {
                id: visualID,
                config: {},
                height: attributes.height,
                width: attributes.width
            };

            console.log('Preparing to load visualization', visualID);
            const loaderEl = $compile(injectLoaderElement)(scope);
            element.append(loaderEl);
            $http.get(`/o/recs/pltf_visualization?_search=true&nd=${new Date().getTime()}&rows=10&page=1&sidx=_id&sord=desc&_id=${visualID}`).then((response) => {
                if (response.status === 200) {
                    const config = JSON.parse(response.data.rows[0].script);//JSON.parse(data.rows[0].script);//JSON.parse(
                    if (config.plotOptions && config.plotOptions.series) {
                        // @ts-ignore
                        config.plotOptions.series.point.events.click = new Function(config.plotOptions.series.point.events.click);
                    }

                    let series = [];
                    config.series.forEach(function (val) {
                        pageService.getbydata(val, (_data) => {
                            // @ts-ignore
                            if (_data instanceof Array) {
                                series = _data;
                            } else {
                                series.push(_data);
                            }

                            if (config.xAxis && config.xAxis.categories) {
                                config.xAxis.categories = [];
                                _data.data.forEach((dt) => {
                                    config.xAxis.categories.push(dt.name);
                                });
                            }

                            config.series = series;
                            scope.widget.config = config;
                            const LElement = $("#loader-" + visualID);
                            const newH = LElement.closest('div').height();
                            const newW = LElement.closest('div').width();
                            if (attributes.height) {
                                scope.widget.height = parseInt(attributes.height);
                            }

                            if (attributes.width) {
                                scope.widget.width = parseInt(attributes.width);
                            }

                            if (!attributes.height) {
                                scope.widget.height = newH;
                            }

                            if (!attributes.width) {
                                scope.widget.width = newW;
                            }

                            const newEl = $compile(injectWidgetElement)(scope);
                            element.append(newEl);
                            LElement.hide();
                            $timeout(function () {
                                LElement.fadeOut();
                                const HElement = $("#chart-" + visualID);
                                HElement.highcharts().setSize(scope.widget.width, scope.widget.height);
                            }, 20);
                        }, "");

                    });
                }
            });


        }
    };
}]);

obto.directive('smartTreeviewContent', function () {
    return {
        restrict: 'E',
        link: function (scope, element) {
            var $content = $(scope.item.content);

            function handleExpanded() {
                $content.find('>i')
                    .toggleClass('fa-folder', !scope.item.expanded)
                    .toggleClass('fa-folder-open', !!scope.item.expanded);

            }

            if (scope.item.top) {
                $content.on('click', function () {
                    scope.$emit("event:topSelected", scope.item.name);
                });
            }

            if (scope.item.children && scope.item.children.length) {
                $content.on('click', function () {
                    scope.$apply(function () {
                        scope.item.expanded = !scope.item.expanded;
                        handleExpanded();
                    });


                });
                handleExpanded();
            } else {
                $content.on('click', function () {

                    if (scope.item.children && scope.item.children.length) {
                        $content.on('click', function () {
                            scope.$apply(function () {
                                scope.item.expanded = !scope.item.expanded;
                                handleExpanded();
                            });


                        });
                        handleExpanded();
                    } else {
                        scope.$emit("event:objectSelected", scope.item);
                    }

                });

            }

            element.replaceWith($content);


        }
    };
});

obto.directive('smartTreeview', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        scope: {
            'items': '=',
            'contextoptions': '='

        },
        template: '<li context-menu="contextoptions" ng-class="{parent_li: item.children.length}" ng-repeat="item in items" role="treeitem">' +
            '<smart-treeview-content></smart-treeview-content>' +
            '<ul ng-if="item.children.length" smart-treeview ng-show="item.expanded"  items="item.children" role="group" class="smart-treeview-group" ></ul>' +
            '</li>',
        compile: function (element) {
            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                post: function (scope, element) {
                    // Compile the contents
                    if (!compiledContents) {
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function (clone) {
                        element.append(clone);
                    });
                }
            };
        }
    };
}]);

obto.directive('onError', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // element.on('error', function () {
            //     element.attr('src', attr.onError);
            // });
            element.bind('error', function () {
                if (attrs.src !== attrs.onError) {
                    attrs.$set('src', attrs.onError);
                }
                scope.$digest();
            });
        }
    };
});

obto.directive('onErrorSrc', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // element.on('error', function () {
            //     element.attr('src', attr.onError);
            // });
            element.bind('error', function () {
                if (attrs.src !== attrs.onErrorSrc) {
                    attrs.$set('src', attrs.onErrorSrc);
                }
                scope.$digest();
            });
        }
    };
});


obto.directive('ladda', ['laddaOption', '$timeout', function (laddaOption, $timeout) {
    return {
        restrict: 'A',
        priority: -1,
        link: function (scope, element, attrs) {
            $timeout(function () {
                element.addClass('ladda-button');
                if (angular.isUndefined(element.attr('data-style'))) {
                    element.attr('data-style', laddaOption.style || 'zoom-in');
                }
                if (angular.isUndefined(element.attr('data-spinner-size')) && laddaOption.spinnerSize) {
                    element.attr('data-spinner-size', laddaOption.spinnerSize);
                }
                if (angular.isUndefined(element.attr('data-spinner-color')) && laddaOption.spinnerColor) {
                    element.attr('data-spinner-color', laddaOption.spinnerColor);
                }

                // ladda breaks childNode's event property.
                // because ladda use innerHTML instead of append node
                if (!element[0].querySelector('.ladda-label')) {
                    var labelWrapper = document.createElement('span');
                    labelWrapper.className = 'ladda-label';
                    angular.element(labelWrapper).append(element.contents());
                    element.append(labelWrapper);
                }

                // create ladda button
                var ladda = Ladda.create(element[0]);

                // add watch!
                scope.$watch(attrs.ladda, function (loading) {
                    if (!loading && !angular.isNumber(loading)) {
                        ladda.stop();
                        // When the button also have the ng-disabled directive it needs to be
                        // re-evaluated since the disabled attribute is removed by the 'stop' method.
                        if (attrs.ngDisabled) {
                            element.attr('disabled', scope.$eval(attrs.ngDisabled));
                        }
                        return;
                    }
                    if (!ladda.isLoading()) {
                        ladda.start();
                    }
                    if (angular.isNumber(loading)) {
                        ladda.setProgress(loading);
                    }
                });

                // use remove on scope destroy to stop memory leaks
                scope.$on('$destroy', function () {
                    if (ladda) { // prevent null reference
                        ladda.remove();
                    }
                });
            });
        }
    };
}]);

angular.element(document).ready(function () {
    angular.bootstrap(document.body, ['obto-view-index'], { strictDi: false });
});
